export const officesMockData = [
    {
        officeId: 3058,
        InternalOfficeId: '1090',
        Name: 'Neptunusplein',
        fullName: 'Assen ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Neptunusplein 1',
        VisitingZipcode: '9401 CZ',
        VisitingCity: 'Assen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0592) 310 750',
        FaxNumber: '',
        Email: 'assen1090@hypotheker.nl',
        OpeningHoursInfo:
            'Op maandag-, woensdag- en donderdagavond zijn wij open op afspraak. \r\n\r\nIn de schoolvakanties zijn wij op zaterdag gesloten.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.998245',
        GeoLocationLongitude: '6.559748',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3702/pandfoto-de-hypotheker-assen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132736672090000000',
        OfficeUrl: '/vestigingen/drenthe/hypotheekadviseur-assen/neptunusplein/',
    },
    {
        OfficeId: 3064,
        InternalOfficeId: '1464',
        Name: 'Kruisstraat',
        FullName: 'Beilen ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Kruisstraat 11A ',
        VisitingZipcode: '9411 PD',
        VisitingCity: 'Beilen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0593) 241 010',
        FaxNumber: '',
        Email: 'beilen1464@hypotheker.nl',
        OpeningHoursInfo:
            'Bezoek aan deze vestiging is uitsluitend op afspraak. Afspraken in de avonduren vinden plaats bij De Hypotheker in Assen (Neptunusplein 1).',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.858764',
        GeoLocationLongitude: '6.518008',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3703/pandfoto-de-hypotheker-beilen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/beilen/kruisstraat/',
    },
    {
        OfficeId: 3059,
        InternalOfficeId: '1125',
        Name: 'Sallandsestraat',
        FullName: 'Coevorden ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Sallandsestraat 108 ',
        VisitingZipcode: '7741 HX',
        VisitingCity: 'Coevorden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0524) 518 833',
        FaxNumber: '',
        Email: 'coevorden1125@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.660888',
        GeoLocationLongitude: '6.736682',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '13:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '13:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3705/pandfoto-de-hypotheker-coevorden-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/coevorden/sallandsestraat/',
    },
    {
        OfficeId: 3060,
        InternalOfficeId: '1120',
        Name: 'Marktplein',
        FullName: 'Emmen ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Marktplein 152 ',
        VisitingZipcode: '7811 BA',
        VisitingCity: 'Emmen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0591) 640 800',
        FaxNumber: '',
        Email: 'emmen1120@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.785919',
        GeoLocationLongitude: '6.892129',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:45', CloseTime: '19:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:45', CloseTime: '19:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:45', CloseTime: '19:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:45', CloseTime: '19:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:45', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3706/pandfoto-de-hypotheker-emmen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/emmen/marktplein/',
    },
    {
        OfficeId: 3061,
        InternalOfficeId: '1031',
        Name: 'Schutstraat',
        FullName: 'Hoogeveen ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Schutstraat 65',
        VisitingZipcode: '7907 CB',
        VisitingCity: 'Hoogeveen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0528) 277 277',
        FaxNumber: '',
        Email: 'hoogeveen1031@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In het centrum naast de Nettorama',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.719934',
        GeoLocationLongitude: '6.474653',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3707/pandfoto-de-hypotheker-hoogeveen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/hoogeveen/schutstraat/',
    },
    {
        OfficeId: 3062,
        InternalOfficeId: '1081',
        Name: 'Stationsweg',
        FullName: 'Meppel ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Stationsweg 70',
        VisitingZipcode: '7941 HG ',
        VisitingCity: 'Meppel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0522) 263 637',
        FaxNumber: '',
        Email: 'meppel1081@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.691882',
        GeoLocationLongitude: '6.197601',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3708/pandfoto-de-hypotheker-meppel-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/meppel/stationsweg/',
    },
    {
        OfficeId: 3137,
        InternalOfficeId: '1449',
        Name: 'Langestraat',
        FullName: 'Klazienaveen ',
        ProvinceId: '2416',
        ProvinceName: 'Drenthe',
        VisitingStreetName: 'Langestraat 504',
        VisitingZipcode: '7891AX',
        VisitingCity: 'Klazienaveen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0591) 708 888',
        FaxNumber: '',
        Email: 'klazienaveen1449@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.724668',
        GeoLocationLongitude: '6.991258',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3709/pandfoto-de-hypotheker-klazienaveen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/drenthe/klazienaveen/langestraat/',
    },
    {
        OfficeId: 3081,
        InternalOfficeId: '1056',
        Name: 'Schoutstraat',
        FullName: 'Almere-Stad ',
        ProvinceId: '2419',
        ProvinceName: 'Flevoland',
        VisitingStreetName: 'Schoutstraat 6',
        VisitingZipcode: '1315 KW',
        VisitingCity: 'Almere-Stad',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(036) 548 93 93',
        FaxNumber: '',
        Email: 'almere1056@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.374392',
        GeoLocationLongitude: '5.217884',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3710/pandfoto-de-hypotheker-almere-2021.jpg?center=0.53,0.46833333333333332&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/flevoland/hypotheekadviseur-almere/schoutstraat/',
    },
    {
        OfficeId: 3082,
        InternalOfficeId: '1415',
        Name: 'De Helling',
        FullName: 'Dronten ',
        ProvinceId: '2419',
        ProvinceName: 'Flevoland',
        VisitingStreetName: 'De Helling 228',
        VisitingZipcode: '8251GH',
        VisitingCity: 'Dronten',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0321) 740 040',
        FaxNumber: '',
        Email: 'dronten1415@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'In het pand van makelaardij Flipse. Gratis parkeren met de blauwe parkeerschijf',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.526578',
        GeoLocationLongitude: '5.716442',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3711/pandfoto-de-hypotheker-dronten-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/flevoland/dronten/de-helling/',
    },
    {
        OfficeId: 3083,
        InternalOfficeId: '1131',
        Name: 'Nagelerstraat',
        FullName: 'Emmeloord ',
        ProvinceId: '2419',
        ProvinceName: 'Flevoland',
        VisitingStreetName: 'Nagelerstraat 7-B',
        VisitingZipcode: '8301 XE',
        VisitingCity: 'Emmeloord',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0527) 611 111',
        FaxNumber: '',
        Email: 'emmeloord1131@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.709176',
        GeoLocationLongitude: '5.754321',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3712/pandfoto-de-hypotheker-emmeloord-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/flevoland/emmeloord/nagelerstraat/',
    },
    {
        OfficeId: 3084,
        InternalOfficeId: '1144',
        Name: 'De Schans 19',
        FullName: 'Lelystad ',
        ProvinceId: '2419',
        ProvinceName: 'Flevoland',
        VisitingStreetName: 'De Schans 19 45',
        VisitingZipcode: '8231 KA',
        VisitingCity: 'Lelystad',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0320) 223 883',
        FaxNumber: '',
        Email: 'lelystad1144@hypotheker.nl',
        OpeningHoursInfo: 'In overleg met de adviseur is een afspraak op zaterdag mogelijk.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Oranje verzamelgebouw en parkeermogelijkheid voor de deur',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.517193',
        GeoLocationLongitude: '5.472938',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '08:30', CloseTime: '12:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3715/pandfoto-de-hypotheker-lelystad-2021.jpg?center=0.4962686567164179,0.47666666666666668&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/flevoland/lelystad/de-schans-19/',
    },
    {
        OfficeId: 6866,
        InternalOfficeId: '1467',
        Name: 'Raadhuisstraat',
        FullName: 'Zeewolde ',
        ProvinceId: '2419',
        ProvinceName: 'Flevoland',
        VisitingStreetName: 'Raadhuisstraat 40',
        VisitingZipcode: '3891 EB',
        VisitingCity: 'Zeewolde',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(036) 525 39 99',
        FaxNumber: '',
        Email: 'zeewolde1467@hypotheker.nl',
        OpeningHoursInfo:
            'Deze vestiging is alleen op afspraak geopend. Bel ons daarom even voordat je langskomt, zodat je zeker weet dat we de tijd voor je kunnen nemen.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gevestigd in het pand van Flevopand Makelaars',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.331933',
        GeoLocationLongitude: '5.544203',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3716/pandfoto-de-hypotheker-zeewolde-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/flevoland/zeewolde/raadhuisstraat/',
    },
    {
        OfficeId: 3052,
        InternalOfficeId: '1367',
        Name: 'Peter van Thaborplein',
        FullName: 'Bolsward ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Peter van Thaborplein 8',
        VisitingZipcode: '8701 EW',
        VisitingCity: 'Bolsward',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0515) 713 000',
        FaxNumber: '',
        Email: 'bolsward1367@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Voorbij het Marne college richting Plein 1455',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.064737',
        GeoLocationLongitude: '5.519251',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3909/pandfoto-de-hypotheker-bolsward-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725382990000000',
        OfficeUrl: '/vestigingen/friesland/bolsward/peter-van-thaborplein/',
    },
    {
        OfficeId: 3053,
        InternalOfficeId: '1317',
        Name: 'Hogepol',
        FullName: 'Dokkum ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Hogepol 15',
        VisitingZipcode: '9101 LZ',
        VisitingCity: 'Dokkum',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0519) 711 000',
        FaxNumber: '',
        Email: 'dokkum1317@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover notaris Hellema',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.326443',
        GeoLocationLongitude: '5.996385',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3770/pandfoto-de-hypotheker-dokkum-2021.jpg?center=0.515,0.65&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/friesland/dokkum/hogepol/',
    },
    {
        OfficeId: 3054,
        InternalOfficeId: '1280',
        Name: 'Kerkstraat',
        FullName: 'Drachten ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Kerkstraat 16',
        VisitingZipcode: '9203 CR',
        VisitingCity: 'Drachten',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0512) 530 455',
        FaxNumber: '',
        Email: 'drachten1280@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.106371',
        GeoLocationLongitude: '6.099666',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3937/pandfoto-de-hypotheker-drachten-2021.jpg?center=0.56,0.55&mode=crop&width=275&height=300&rnd=132737450310000000',
        OfficeUrl: '/vestigingen/friesland/drachten/kerkstraat/',
    },
    {
        OfficeId: 3055,
        InternalOfficeId: '1149',
        Name: 'Atalantastraat',
        FullName: 'Heerenveen ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Atlantastraat 33',
        VisitingZipcode: '8448 EZ',
        VisitingCity: 'Heerenveen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0513) 622 441',
        FaxNumber: '',
        Email: 'heerenveen1149@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover het Abe Lenstra stadion. Gratis parkeren naast de deur',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.959475',
        GeoLocationLongitude: '5.932291',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3789/pandfoto-de-hypotheker-heerenveen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/friesland/heerenveen/atalantastraat/',
    },
    {
        OfficeId: 3056,
        InternalOfficeId: '1224',
        Name: 'Achter de Hoven',
        FullName: 'Leeuwarden ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Achter de Hoven 73',
        VisitingZipcode: '8933 AH',
        VisitingCity: 'Leeuwarden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(058) 212 71 22',
        FaxNumber: '',
        Email: 'leeuwarden1224@hypotheker.nl',
        OpeningHoursInfo:
            'Wij zijn iedere dag telefonisch bereikbaar van 8:30 tot 17:30 uur. In de avonden zijn wij op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis parkeren voor de deur (met parkeerschijf)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.198325',
        GeoLocationLongitude: '5.80214',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3807/pandfoto-de-hypotheker-leeuwarden-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/friesland/leeuwarden/achter-de-hoven/',
    },
    {
        OfficeId: 3057,
        InternalOfficeId: '1060',
        Name: 'Oude Koemarkt',
        FullName: 'Sneek ',
        ProvinceId: '2415',
        ProvinceName: 'Friesland',
        VisitingStreetName: 'Oude Koemarkt 46',
        VisitingZipcode: '8601 EK',
        VisitingCity: 'Sneek',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0515) 423 232',
        FaxNumber: '',
        Email: 'sneek1060@hypotheker.nl',
        OpeningHoursInfo: 'Op zaterdagen zijn wij geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover de Waterpoort richting het centrum',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.029721',
        GeoLocationLongitude: '5.660004',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3848/pandfoto-de-hypotheker-sneek-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/friesland/sneek/oude-koemarkt/',
    },
    {
        OfficeId: 3011,
        InternalOfficeId: '1117',
        Name: 'Regentesselaan',
        FullName: 'Apeldoorn ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Regentesselaan 1',
        VisitingZipcode: '7316 AA',
        VisitingCity: 'Apeldoorn',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(055) 521 17 81',
        FaxNumber: '',
        Email: 'apeldoorn1117@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Hoek Regentesselaan, Stationsstraat en Deventerstraat, tegenover Zorgsaam. Parkeren voor de deur is mogelijk',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.21665',
        GeoLocationLongitude: '5.964192',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '19:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3898/pandfoto-de-hypotheker-apeldoorn-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-apeldoorn/regentesselaan/',
    },
    {
        OfficeId: 3012,
        InternalOfficeId: '1042',
        Name: 'Steenstraat',
        FullName: 'Arnhem Centrum',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Steenstraat 9a',
        VisitingZipcode: '6828 CA',
        VisitingCity: 'Arnhem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(026) 76 00 700',
        FaxNumber: '',
        Email: 'arnhem1042@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.983646',
        GeoLocationLongitude: '5.915129',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3739/pandfoto-de-hypotheker-arnhem-centrum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-arnhem/steenstraat/',
    },
    {
        OfficeId: 3013,
        InternalOfficeId: '1235',
        Name: 'Kronenburgsingel',
        FullName: 'Arnhem Zuid',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Kronenburgsingel 23a',
        VisitingZipcode: '6831 GD',
        VisitingCity: 'Arnhem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(026) 760 11 11',
        FaxNumber: '',
        Email: 'arnhem1235@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.96041',
        GeoLocationLongitude: '5.898822',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3740/pandfoto-de-hypotheker-arnhem-zuid-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-arnhem/kronenburgsingel/',
    },
    {
        OfficeId: 3014,
        InternalOfficeId: '1350',
        Name: 'Amersfoortsestraat',
        FullName: 'Barneveld ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Amersfoortsestraat 47',
        VisitingZipcode: '3772 CG',
        VisitingCity: 'Barneveld',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0342) 400 919',
        FaxNumber: '',
        Email: 'barneveld1350@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Parkeren voor de deur mogelijk',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.136677',
        GeoLocationLongitude: '5.581204',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3242/pandfoto-de-hypotheker-barneveld-2021.jpg?center=0.515,0.285&mode=crop&width=275&height=300&rnd=132718671780000000',
        OfficeUrl: '/vestigingen/gelderland/barneveld/amersfoortsestraat/',
    },
    {
        OfficeId: 3015,
        InternalOfficeId: '1424',
        Name: 'De Plak',
        FullName: 'Bemmel ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'De Plak 17',
        VisitingZipcode: '6681 DN',
        VisitingCity: 'Bemmel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0481) 760 760',
        FaxNumber: '',
        Email: 'arnhem1235@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.895504',
        GeoLocationLongitude: '5.894725',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3745/pandfoto-de-hypotheker-bemmel-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/gelderland/bemmel/de-plak/',
    },
    {
        OfficeId: 3016,
        InternalOfficeId: '1414',
        Name: 'Van Heemstraweg',
        FullName: 'Beuningen ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Van Heemstraweg 64B',
        VisitingZipcode: '6641 AG',
        VisitingCity: 'Beuningen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(024) 645 24 25',
        FaxNumber: '',
        Email: 'beuningen1414@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Boven de bioscoop en pannenkoekrestaurant Den Tol',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.865179',
        GeoLocationLongitude: '5.772515',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3749/panfdoto-de-hypotheker-beuningen-2021.jpg?center=0.5025,0.42&mode=crop&width=275&height=300&rnd=132725417820000000',
        OfficeUrl: '/vestigingen/gelderland/beuningen/van-heemstraweg/',
    },
    {
        OfficeId: 3017,
        InternalOfficeId: '1384',
        Name: 'Markt',
        FullName: 'Culemborg ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Markt 28',
        VisitingZipcode: '4101 BX',
        VisitingCity: 'Culemborg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0345) 533 900',
        FaxNumber: '',
        Email: 'culemborg1384@hypotheker.nl',
        OpeningHoursInfo:
            'Op maandag- t/m donderdagavond en op zaterdag zijn wij geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.957423',
        GeoLocationLongitude: '5.225587',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1104/office_1384.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731060000000',
        OfficeUrl: '/vestigingen/gelderland/culemborg/markt/',
    },
    {
        OfficeId: 3018,
        InternalOfficeId: '1062',
        Name: 'Walstraat',
        FullName: 'Doetinchem ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Walstraat 82',
        VisitingZipcode: '7001 BV',
        VisitingCity: 'Doetinchem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0314) 360 203',
        FaxNumber: '',
        Email: 'doetinchem1062@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover Schuurman Schoenen',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.966938',
        GeoLocationLongitude: '6.288315',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3888/pandfoto-de-hypotheker-doetinchem-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/gelderland/doetinchem/walstraat/',
    },
    {
        OfficeId: 3019,
        InternalOfficeId: '1049',
        Name: 'Telefoonweg',
        FullName: 'Ede ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Telefoonweg 120',
        VisitingZipcode: '6713 AL',
        VisitingCity: 'Ede',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0318) 651 042',
        FaxNumber: '',
        Email: 'ede1049@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: "Tegenover station 'Ede centrum'. Parkeren mogelijk op het Kuiperplein",
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.043795',
        GeoLocationLongitude: '5.6678',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4061/pandfoto-de-hypotheker-ede-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132798967310000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadvies-ede/telefoonweg/',
    },
    {
        OfficeId: 3021,
        InternalOfficeId: '1048',
        Name: 'Luttekepoortstraat',
        FullName: 'Harderwijk ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Luttekepoortstraat 136',
        VisitingZipcode: '3841 AX',
        VisitingCity: 'Harderwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0341) 422 724',
        FaxNumber: '',
        Email: 'harderwijk1048@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis 2 uur parkeren achter de vestiging bij AH',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.348363',
        GeoLocationLongitude: '5.622896',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3787/pandfoto-de-hypotheker-harderwijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/gelderland/harderwijk/luttekepoortstraat/',
    },
    {
        OfficeId: 3022,
        InternalOfficeId: '1434',
        Name: 'Edith Piafstraat',
        FullName: 'Lent ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Edith Piafstraat 110',
        VisitingZipcode: '6663 MA',
        VisitingCity: 'Lent',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(024) 360 55 40',
        FaxNumber: '',
        Email: 'lent1434@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de doorgaande weg van Nijmegen naar Arnhem',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.869513',
        GeoLocationLongitude: '5.86041',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3812/pandfoto-de-hypotheker-lent-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/gelderland/lent/edith-piafstraat/',
    },
    {
        OfficeId: 3140,
        InternalOfficeId: '1452',
        Name: 'Hoeflingweg',
        FullName: 'Lochem ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Hoeflingweg 7',
        VisitingZipcode: '7241 CJ',
        VisitingCity: 'Lochem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0573) 215 007',
        FaxNumber: '',
        Email: 'lochem1452@hypotheker.nl',
        OpeningHoursInfo: 'Bezoek aan deze vestiging is uitsluitend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.164403',
        GeoLocationLongitude: '6.404312',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3901/pandfoto-de-hypotheker-lochem-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719130000000',
        OfficeUrl: '/vestigingen/gelderland/lochem/hoeflingweg/',
    },
    {
        OfficeId: 3023,
        InternalOfficeId: '1067',
        Name: 'St. Canisiussingel',
        FullName: 'Nijmegen Centrum',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'St. Canisiussingel 36a ',
        VisitingZipcode: '6511 TJ',
        VisitingCity: 'Nijmegen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(024) 360 55 40',
        FaxNumber: '',
        Email: 'nijmegen1067@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Vestiging bereikbaar via de Ventweg. Gratis parkeren op onze parkeerplaats',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.843963',
        GeoLocationLongitude: '5.869835',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3821/pandfoto-de-hypotheker-nijmegen-centrum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-nijmegen/st-canisiussingel/',
    },
    {
        OfficeId: 3024,
        InternalOfficeId: '1351',
        Name: 'Wijchenseweg',
        FullName: 'Nijmegen Dukenburg',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Wijchenseweg 122',
        VisitingZipcode: '6538 SX',
        VisitingCity: 'Nijmegen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(024) 344 58 00',
        FaxNumber: '',
        Email: 'nijmegen1351@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Tussen het Takenhofplein en de woonboulevard. Gratis parkeren achter het kantoor',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.82516',
        GeoLocationLongitude: '5.795491',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3822/pandfoto-de-hypotheker-nijmegen-dukenberg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-nijmegen/wijchenseweg/',
    },
    {
        OfficeId: 3025,
        InternalOfficeId: '1400',
        Name: 'Galvaniweg',
        FullName: 'Nunspeet ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Galvaniweg 7',
        VisitingZipcode: '8071 SC',
        VisitingCity: 'Nunspeet',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0341) 728 000',
        FaxNumber: '',
        Email: 'nunspeet1400@hypotheker.nl',
        OpeningHoursInfo: 'In overleg met de adviseur is een afspraak op zaterdag mogelijk.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover de Praxis. Parkeermogelijkheid voor de deur',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.374943',
        GeoLocationLongitude: '5.766469',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3826/pandfoto-de-hypotheker-nunspeet-2021-2.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/gelderland/nunspeet/galvaniweg/',
    },
    {
        OfficeId: 3026,
        InternalOfficeId: '1093',
        Name: 'Oude Haven',
        FullName: 'Tiel ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Oude Haven 75',
        VisitingZipcode: '4001 LZ',
        VisitingCity: 'Tiel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0344) 635 050',
        FaxNumber: '',
        Email: 'tiel1093@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.888506',
        GeoLocationLongitude: '5.438521',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3921/pandfoto-de-hypotheker-tiel-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725445040000000',
        OfficeUrl: '/vestigingen/gelderland/tiel/oude-haven/',
    },
    {
        OfficeId: 3027,
        InternalOfficeId: '1419',
        Name: 'Hoofdstraat',
        FullName: 'Velp ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Hoofdstraat 198',
        VisitingZipcode: '6881 TN ',
        VisitingCity: 'Velp',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(026) 361 17 17',
        FaxNumber: '',
        Email: 'arnhem1042@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.998568',
        GeoLocationLongitude: '5.969951',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3896/pandfoto-de-hypotheker-velp-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/gelderland/velp/hoofdstraat/',
    },
    {
        OfficeId: 3028,
        InternalOfficeId: '1126',
        Name: 'Kasteellaan',
        FullName: 'Wijchen ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Kasteellaan 10',
        VisitingZipcode: '6602 DE',
        VisitingCity: 'Wijchen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(024) 645 24 25',
        FaxNumber: '',
        Email: 'wijchen1126@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover het Kasteel van Wijchen',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.807609',
        GeoLocationLongitude: '5.727586',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4002/29.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132785095280000000',
        OfficeUrl: '/vestigingen/gelderland/hypotheekadviseur-wijchen/kasteellaan/',
    },
    {
        OfficeId: 3029,
        InternalOfficeId: '1324',
        Name: 'Ratumsestraat',
        FullName: 'Winterswijk ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Ratumsestraat 35b',
        VisitingZipcode: '7101 MT',
        VisitingCity: 'Winterswijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0543) 535 556',
        FaxNumber: '',
        Email: 'winterswijk1324@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.972097',
        GeoLocationLongitude: '6.723198',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3170/pandfoto-de-hypotheker-winterswijk-2021.jpg?center=0.5125,0.465&mode=crop&width=275&height=300&rnd=132712563500000000',
        OfficeUrl: '/vestigingen/gelderland/winterswijk/ratumsestraat/',
    },
    {
        OfficeId: 3030,
        InternalOfficeId: '1432',
        Name: 'Kampsingel',
        FullName: 'Zevenaar ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Kampsingel 3A',
        VisitingZipcode: '6901 JC',
        VisitingCity: 'Zevenaar',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0316) 215 006',
        FaxNumber: '',
        Email: 'zevenaar1432@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.931209',
        GeoLocationLongitude: '6.077815',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3883/pandfoto-de-hypotheker-zevenaar-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/gelderland/zevenaar/kampsingel/',
    },
    {
        OfficeId: 3031,
        InternalOfficeId: '1110',
        Name: 'Nieuwstad',
        FullName: 'Zutphen ',
        ProvinceId: '2413',
        ProvinceName: 'Gelderland',
        VisitingStreetName: 'Nieuwstad 65',
        VisitingZipcode: '7201 NL',
        VisitingCity: 'Zutphen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0575) 545 028',
        FaxNumber: '',
        Email: 'zutphen1110@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover het Boudartius College',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.14502',
        GeoLocationLongitude: '6.197318',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3885/pandfoto-de-hypotheker-zutphen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/gelderland/zutphen/nieuwstad/',
    },
    {
        OfficeId: 3006,
        InternalOfficeId: '1438',
        Name: 'Overdiep',
        FullName: 'Appingedam ',
        ProvinceId: '2232',
        ProvinceName: 'Groningen',
        VisitingStreetName: 'Overdiep 3',
        VisitingZipcode: '9902 DB',
        VisitingCity: 'Appingedam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0596) 229 001',
        FaxNumber: '',
        Email: 'appingedam1438@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gevestigd in het kantoor van Nieboer Makelaars',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.318583',
        GeoLocationLongitude: '6.859299',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3738/pandfoto-de-hypotheker-appingedam-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/groningen/appingedam/overdiep/',
    },
    {
        OfficeId: 3007,
        InternalOfficeId: '1202',
        Name: 'Westerhaven',
        FullName: 'Groningen ',
        ProvinceId: '2232',
        ProvinceName: 'Groningen',
        VisitingStreetName: 'Westerhaven 9',
        VisitingZipcode: '9718 AV',
        VisitingCity: 'Groningen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(050) 314 41 33',
        FaxNumber: '',
        Email: 'groningen1202@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.215041',
        GeoLocationLongitude: '6.556347',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3783/pandfoto-de-hypotheker-groningen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/groningen/groningen/westerhaven/',
    },
    {
        OfficeId: 3008,
        InternalOfficeId: '1112',
        Name: 'Lilienthalplein',
        FullName: 'Stadskanaal ',
        ProvinceId: '2232',
        ProvinceName: 'Groningen',
        VisitingStreetName: 'Lilienthalplein 27',
        VisitingZipcode: '9501 XP',
        VisitingCity: 'Stadskanaal',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0599) 622 524',
        FaxNumber: '',
        Email: 'stadskanaal1112@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.989781',
        GeoLocationLongitude: '6.951632',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3894/pandfoto-de-hypotheker-stadskanaal-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/groningen/stadskanaal/lilienthalplein/',
    },
    {
        OfficeId: 3009,
        InternalOfficeId: '1227',
        Name: 'Veenlustpassage',
        FullName: 'Veendam ',
        ProvinceId: '2232',
        ProvinceName: 'Groningen',
        VisitingStreetName: 'Veenlustpassage 20',
        VisitingZipcode: '9641 MK',
        VisitingCity: 'Veendam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0598) 618 833',
        FaxNumber: '',
        Email: 'veendam1227@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.106207',
        GeoLocationLongitude: '6.88021',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3895/pandfoto-de-hypotheker-veendam-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/groningen/veendam/veenlustpassage/',
    },
    {
        OfficeId: 3010,
        InternalOfficeId: '1180',
        Name: 'Venne',
        FullName: 'Winschoten ',
        ProvinceId: '2232',
        ProvinceName: 'Groningen',
        VisitingStreetName: 'Venne 122',
        VisitingZipcode: '9671 EW',
        VisitingCity: 'Winschoten',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0597) 430 970',
        FaxNumber: '',
        Email: 'winschoten1180@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de voorzijde van de Action. Vrij parkeren om de hoek',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '53.144574',
        GeoLocationLongitude: '7.034589',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3877/pandfoto-de-hypotheker-winschoten-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/groningen/winschoten/venne/',
    },
    {
        OfficeId: 3085,
        InternalOfficeId: '1218',
        Name: 'Geerstraat',
        FullName: 'Heerlen ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Geerstraat 46',
        VisitingZipcode: '6411 NS',
        VisitingCity: 'Heerlen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(045) 574 14 54',
        FaxNumber: '',
        Email: 'heerlen1218@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '50.888571',
        GeoLocationLongitude: '5.973545',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4024/pandfoto-de-hypotheker-heerlen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132791891600000000',
        OfficeUrl: '/vestigingen/limburg/heerlen/geerstraat/',
    },
    {
        OfficeId: 3086,
        InternalOfficeId: '1194',
        Name: 'Avenue Ceramique',
        FullName: 'Maastricht ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Avenue Céramique 12',
        VisitingZipcode: '6221 KV',
        VisitingCity: 'Maastricht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(043) 356 10 61',
        FaxNumber: '',
        Email: 'maastricht1194@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '50.846574',
        GeoLocationLongitude: '5.702549',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3816/pandfoto-de-hypotheker-maastricht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/limburg/maastricht/avenue-ceramique/',
    },
    {
        OfficeId: 3087,
        InternalOfficeId: '1210',
        Name: 'Godsweerdersingel',
        FullName: 'Roermond ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Godsweerdersingel 7',
        VisitingZipcode: '6041 GJ',
        VisitingCity: 'Roermond',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0475) 311 011',
        FaxNumber: '',
        Email: 'roermond1210@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken op zaterdag en in de avonduren zijn op afspraak en in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.19333',
        GeoLocationLongitude: '5.992805',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3835/pandfoto-de-hypotheker-roermond-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/limburg/hypotheekadvies-roermond/godsweerdersingel/',
    },
    {
        OfficeId: 3088,
        InternalOfficeId: '1152',
        Name: 'Odasingel',
        FullName: 'Sittard ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Odasingel 1001-1003',
        VisitingZipcode: '6131 GT',
        VisitingCity: 'Sittard',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(046) 452 52 52',
        FaxNumber: '',
        Email: 'sittard1152@hypotheker.nl',
        OpeningHoursInfo: 'Na 17:00 zijn wij alleen geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Hoek Odasingel – Paardestraat, onderin de Rosatoren ',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.000134',
        GeoLocationLongitude: '5.873354',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '16:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3422/pandfoto-de-hypotheker-sittard-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132712581210000000',
        OfficeUrl: '/vestigingen/limburg/sittard/odasingel/',
    },
    {
        OfficeId: 3089,
        InternalOfficeId: '1150',
        Name: 'Parade',
        FullName: 'Venlo ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Parade 63',
        VisitingZipcode: '5911 CB',
        VisitingCity: 'Venlo',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(077) 352 15 00',
        FaxNumber: '',
        Email: 'venlo1150@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken op zaterdag en in de avonduren zijn op afspraak en in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.368156',
        GeoLocationLongitude: '6.170937',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3924/pandfoto-de-hypotheker-venlo-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725452050000000',
        OfficeUrl: '/vestigingen/limburg/venlo/parade/',
    },
    {
        OfficeId: 3090,
        InternalOfficeId: '1437',
        Name: 'Henseniusplein',
        FullName: 'Venray ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Henseniusplein 8',
        VisitingZipcode: '5801 BB',
        VisitingCity: 'Venray',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0478) 53 01 50',
        FaxNumber: '',
        Email: 'venray1437@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast het Schouwburgplein. Parkeermogelijkheid in parkeergarage Gouden Leeuw',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.524439',
        GeoLocationLongitude: '5.973936',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3869/pandfoto-de-hypotheker-venray-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/limburg/venray/henseniusplein/',
    },
    {
        OfficeId: 3091,
        InternalOfficeId: '1148',
        Name: 'Wilhelminasingel',
        FullName: 'Weert ',
        ProvinceId: '2463',
        ProvinceName: 'Limburg',
        VisitingStreetName: 'Wilhelminasingel 165',
        VisitingZipcode: '6001 GS',
        VisitingCity: 'Weert',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0495) 546 460',
        FaxNumber: '',
        Email: 'weert1148@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken op zaterdag en in de avonduren zijn op afspraak en in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.252274',
        GeoLocationLongitude: '5.703677',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '08:30', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3875/pandfoto-de-hypotheker-weert-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/limburg/weert/wilhelminasingel/',
    },
    {
        OfficeId: 3033,
        InternalOfficeId: '1035',
        Name: 'Burgemeester van Hasseltstraat',
        FullName: 'Bergen Op Zoom ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Burgemeester van Hasseltstraat 78',
        VisitingZipcode: '4611 BH',
        VisitingCity: 'Bergen op Zoom',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0164) 259 800',
        FaxNumber: '',
        Email: 'bergenopzoom1035@hypotheker.nl',
        OpeningHoursInfo: 'Op zaterdag zijn wij in de ochtend geopend in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.492341',
        GeoLocationLongitude: '4.292284',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3911/pandfoto-de-hypotheker-bergen-op-zoom-2021.jpg?center=0.5225,0.47333333333333333&mode=crop&width=275&height=300&rnd=132725394340000000',
        OfficeUrl: '/vestigingen/noord-brabant/bergen-op-zoom/burgemeester-van-hasseltstraat/',
    },
    {
        OfficeId: 3034,
        InternalOfficeId: '1175',
        Name: 'Zonnewende',
        FullName: 'Best ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Zonnewende 133',
        VisitingZipcode: '5683 AB',
        VisitingCity: 'Best',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0499) 332 533',
        FaxNumber: '',
        Email: 'best1175@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.510804',
        GeoLocationLongitude: '5.394695',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3910/pandfoto-de-hypotheker-best-2021.jpg?center=0.545,0.53166666666666662&mode=crop&width=275&height=300&rnd=132725391140000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-best/zonnewende/',
    },
    {
        OfficeId: 3035,
        InternalOfficeId: '1366',
        Name: 'Burgemeester Verkuijlstraat',
        FullName: 'Boxmeer ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Burgemeester Verkuijlstraat 49',
        VisitingZipcode: '5831 EJ',
        VisitingCity: 'Boxmeer',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0485) 571 620',
        FaxNumber: '',
        Email: 'boxmeer1366@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Hoek Bilderbeekstraat - Burg. Verkuijlstraat',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.64617',
        GeoLocationLongitude: '5.94712',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3752/pandfoto-de-hypotheker-boxmeer-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-brabant/boxmeer/burgemeester-verkuijlstraat/',
    },
    {
        OfficeId: 3036,
        InternalOfficeId: '1017',
        Name: 'Van Coothplein',
        FullName: 'Breda ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Van Coothplein 103',
        VisitingZipcode: '4811 ND',
        VisitingCity: 'Breda',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(076) 522 25 43',
        FaxNumber: '',
        Email: 'breda1017@hypotheker.nl',
        OpeningHoursInfo:
            'Je kunt een afspraak inplannen via het secretariaat.\r\nVrij inloopspreekuur elke donderdag tussen 14:00 en 17:00 uur',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.583241',
        GeoLocationLongitude: '4.774713',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3753/pandfoto-de-hypotheker-breda-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-brabant/breda/van-coothplein/',
    },
    {
        OfficeId: 6650,
        InternalOfficeId: '1466',
        Name: 'Maasburg',
        FullName: 'Cuijk ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Maasburg 13',
        VisitingZipcode: '5431 BR',
        VisitingCity: 'Cuijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0485) 571 620',
        FaxNumber: '',
        Email: 'cuijk1466@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In winkelcentrum Maasburg, ingang Grotestraat',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.729646',
        GeoLocationLongitude: '5.881079',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:30 - 12:30', CloseTime: '13:30 - 17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:30 - 12:30', CloseTime: '13:30 - 21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:30 - 12:30', CloseTime: '13:30 - 17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:30 - 12:30', CloseTime: '13:30 - 17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:30 - 12:30', CloseTime: '13:30 - 17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3758/pandfoto-de-hypotheker-cuijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-brabant/cuijk/maasburg/',
    },
    {
        OfficeId: 3037,
        InternalOfficeId: '1088',
        Name: 'Stationsweg',
        FullName: 'Den Bosch ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Stationsweg 3',
        VisitingZipcode: '5211 TV',
        VisitingCity: 'Den Bosch',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(073) 612 47 00',
        FaxNumber: '',
        Email: 'denbosch1088@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Drie minuten lopen van het Centraal Station. Schuin tegenover Banketbakkerij Jan de Groot',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.6906',
        GeoLocationLongitude: '5.29791',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3931/pandfoto-s-de-hypotheker-den-bosch-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725500010000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadvies-den-bosch/stationsweg/',
    },
    {
        OfficeId: 3038,
        InternalOfficeId: '1153',
        Name: 'Aalsterweg',
        FullName: 'Eindhoven Aalsterweg',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Aalsterweg 1 ',
        VisitingZipcode: '5615 CA',
        VisitingCity: 'Eindhoven',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(040) 212 80 81',
        FaxNumber: '',
        Email: 'eindhoven1153@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Kruispunt Aalsterweg/ Leenderweg',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.427656',
        GeoLocationLongitude: '5.48699',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3928/pandfoto-de-hypotheker-eindhoven-aalsterweg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725459220000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-eindhoven/aalsterweg/',
    },
    {
        OfficeId: 3039,
        InternalOfficeId: '1222',
        Name: 'Pastoriestraat',
        FullName: 'Eindhoven Pastoriestraat',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Pastoriestraat 153a',
        VisitingZipcode: '5612 EK',
        VisitingCity: 'Eindhoven',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(040) 246 36 55',
        FaxNumber: '',
        Email: 'eindhoven1222@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de rondweg, nabij de Woenselse Markt',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.452555',
        GeoLocationLongitude: '5.472118',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3775/pandfoto-de-hypotheker-eindhoven-pastoriestraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-eindhoven/pastoriestraat/',
    },
    {
        OfficeId: 3040,
        InternalOfficeId: '1102',
        Name: 'Oude Bredaseweg',
        FullName: 'Etten-Leur ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Oude Bredaseweg 5b',
        VisitingZipcode: '4872 AB',
        VisitingCity: 'Etten-Leur',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(076) 501 99 92',
        FaxNumber: '',
        Email: 'ettenleur1102@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.570001',
        GeoLocationLongitude: '4.636573',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3779/pandfoto-de-hypotheker-etten-leur-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-brabant/etten-leur/oude-bredaseweg/',
    },
    {
        OfficeId: 3041,
        InternalOfficeId: '1221',
        Name: 'Zuid Koninginnewal',
        FullName: 'Helmond ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Zuid Koninginnewal 37',
        VisitingZipcode: '5701 NS',
        VisitingCity: 'Helmond',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0492) 550 655',
        FaxNumber: '',
        Email: 'helmond1221@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.477929',
        GeoLocationLongitude: '5.657153',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3793/pandfoto-de-hypotheker-helmond-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-brabant/helmond/zuid-koninginnewal/',
    },
    {
        OfficeId: 3042,
        InternalOfficeId: '1201',
        Name: 'Bredaseweg',
        FullName: 'Oosterhout ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Bredaseweg 35',
        VisitingZipcode: '4901 KN',
        VisitingCity: 'Oosterhout',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0162) 450 552',
        FaxNumber: '',
        Email: 'oosterhout1201@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: "Op kruispunt 'trommelen' richting parkeergarage Bouwlingplein",
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.642219',
        GeoLocationLongitude: '4.851626',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3827/pandfoto-de-hypotheker-oosterhout-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-brabant/oosterhout/bredaseweg/',
    },
    {
        OfficeId: 3043,
        InternalOfficeId: '1107',
        Name: 'Walstraat',
        FullName: 'Oss ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Walstraat 31',
        VisitingZipcode: '5341 CJ',
        VisitingCity: 'Oss',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0412) 640 435 / WhatsApp: (06) 21550608 ',
        FaxNumber: '',
        Email: 'oss1107@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken na 17:30 uur zijn mogelijk in overleg met de adviseur. Het kantoor is in de avonduren enkel op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Tegenover Hotel de Weverij. Parkeergelegenheid aan de overkant in de parkeergarage van BergOss',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.76846',
        GeoLocationLongitude: '5.527657',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3905/pandfoto-de-hypotheker-oss-2021.jpg?center=0.52117263843648209,0.36&mode=crop&width=275&height=300&rnd=132725373830000000',
        OfficeUrl: '/vestigingen/noord-brabant/oss/walstraat/',
    },
    {
        OfficeId: 3044,
        InternalOfficeId: '1431',
        Name: 'Gangboord',
        FullName: 'Raamsdonksveer ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Gangboord 1',
        VisitingZipcode: '4941 RE',
        VisitingCity: 'Raamsdonksveer',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0162) 748 192',
        FaxNumber: '',
        Email: 'raamsdonksveer1431@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover de Albert Heijn',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.69653',
        GeoLocationLongitude: '4.872606',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3900/pandfoto-de-hypotheker-raamsdonkveer-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719130000000',
        OfficeUrl: '/vestigingen/noord-brabant/raamsdonksveer/gangboord/',
    },
    {
        OfficeId: 3047,
        InternalOfficeId: '1220',
        Name: 'Laan van Limburg',
        FullName: 'Roosendaal ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Laan van Limburg 14',
        VisitingZipcode: '4701 BP',
        VisitingCity: 'Roosendaal',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0165) 563 530',
        FaxNumber: '',
        Email: 'roosendaal1220@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.529616',
        GeoLocationLongitude: '4.453984',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3610/pandfoto-de-hypotheker-roosendaal-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132712596130000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-roosendaal/laan-van-limburg/',
    },
    {
        OfficeId: 6597,
        InternalOfficeId: '1409',
        Name: 'Catelijnen',
        FullName: 'Rosmalen ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Catelijnen 1',
        VisitingZipcode: '5241 CW',
        VisitingCity: 'Rosmalen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(073) 303 67 09',
        FaxNumber: '',
        Email: 'rosmalen1409@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis parkeren voor de deur (met parkeerschijf)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.717487',
        GeoLocationLongitude: '5.361455',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3149/pandfoto-de-hypotheker-rosmalen-2021.jpg?center=0.5225,0.45666666666666667&mode=crop&width=275&height=300&rnd=132712597300000000',
        OfficeUrl: '/vestigingen/noord-brabant/rosmalen/catelijnen/',
    },
    {
        OfficeId: 3046,
        InternalOfficeId: '1156',
        Name: 'Kijkduinlaan',
        FullName: 'Tilburg Reeshof',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Kijkduinlaan 99',
        VisitingZipcode: '5045 PH',
        VisitingCity: 'Tilburg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(013) 514 45 35',
        FaxNumber: '',
        Email: 'tilburg1156@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover La Vista Duna',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.576201',
        GeoLocationLongitude: '4.994796',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3856/pandfoto-de-hypotheker-tilburg-reeshof-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-tilburg/kijkduinlaan/',
    },
    {
        OfficeId: 3045,
        InternalOfficeId: '1214',
        Name: 'Spoorlaan',
        FullName: 'Tilburg Centrum',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Spoorlaan 396',
        VisitingZipcode: '5038 CG',
        VisitingCity: 'Tilburg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(013) 536 93 31',
        FaxNumber: '',
        Email: 'tilburg1214@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.559869',
        GeoLocationLongitude: '5.084863',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1134/pandfoto-de-hypotheker-tilburg-centrum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731060000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-tilburg/spoorlaan/',
    },
    {
        OfficeId: 3048,
        InternalOfficeId: '1143',
        Name: 'Kastanjeweg',
        FullName: 'Uden ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Kastanjeweg 149',
        VisitingZipcode: '5401 GW',
        VisitingCity: 'Uden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0413) 245 055',
        FaxNumber: '',
        Email: '1404@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden zijn in overleg mogelijk (ook op zaterdagochtend).',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.657966',
        GeoLocationLongitude: '5.617969',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3599/pandfoto-de-hypotheker-uden-2021.jpg?center=0.51,0.35&mode=crop&width=275&height=300&rnd=132712600670000000',
        OfficeUrl: '/vestigingen/noord-brabant/uden/kastanjeweg/',
    },
    {
        OfficeId: 3049,
        InternalOfficeId: '1404',
        Name: 'Stationsstraat',
        FullName: 'Veghel ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Stationsstraat 20a',
        VisitingZipcode: '5461JV',
        VisitingCity: 'Veghel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0413) 245 055',
        FaxNumber: '',
        Email: '1404@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden zijn in overleg mogelijk (ook op zaterdagochtend).',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Fysieke locatie tijdelijk gesloten: wel telefonisch bereikbaar en per e-mail. Fysiek kunt u langskomen op onze vestiging in Uden.',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.618535',
        GeoLocationLongitude: '5.545472',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1102/office_1404.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731060000000',
        OfficeUrl: '/vestigingen/noord-brabant/veghel/stationsstraat/',
    },
    {
        OfficeId: 3050,
        InternalOfficeId: '1118',
        Name: 'Nieuwstraat',
        FullName: 'Veldhoven ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Nieuwstraat 3',
        VisitingZipcode: '5504 EA',
        VisitingCity: 'Veldhoven',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(040) 255 31 50',
        FaxNumber: '',
        Email: 'veldhoven1118@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Ter hoogte van kruispunt Kromstraat, de Plank en Nieuwstraat',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.403456',
        GeoLocationLongitude: '5.39272',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1192/pandfoto-de-hypotheker-veldhoven-2021.jpg?center=0.5525,0.60833333333333328&mode=crop&width=275&height=300&rnd=132723731080000000',
        OfficeUrl: '/vestigingen/noord-brabant/hypotheekadviseur-veldhoven/nieuwstraat/',
    },
    {
        OfficeId: 3051,
        InternalOfficeId: '1165',
        Name: 'Grotestraat',
        FullName: 'Waalwijk ',
        ProvinceId: '2414',
        ProvinceName: 'Noord-Brabant',
        VisitingStreetName: 'Grotestraat 299',
        VisitingZipcode: '5141 JT',
        VisitingCity: 'Waalwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0416) 671 767',
        FaxNumber: '',
        Email: 'waalwijk1165@hypotheker.nl',
        OpeningHoursInfo: 'Tijdens de vakantieperiode kunnen andere openingstijden gelden.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '250 meter vanaf afslag 38 (vanaf A59). Gratis parkeren op 100 meter afstand',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.690836',
        GeoLocationLongitude: '5.069402',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '20:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3925/pandfoto-de-hypotheker-waalwijk-2021.jpg?center=0.535,0.43666666666666665&mode=crop&width=275&height=300&rnd=132725454110000000',
        OfficeUrl: '/vestigingen/noord-brabant/waalwijk/grotestraat/',
    },
    {
        OfficeId: 2962,
        InternalOfficeId: '1068',
        Name: 'Geestersingel',
        FullName: 'Alkmaar ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Geestersingel 27-28',
        VisitingZipcode: '1815 BA',
        VisitingCity: 'Alkmaar',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(072) 515 14 15',
        FaxNumber: '',
        Email: 'alkmaar1068@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.634706',
        GeoLocationLongitude: '4.742391',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3722/pandfoto-de-hypotheker-alkmaar-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/alkmaar/geestersingel/',
    },
    {
        OfficeId: 2963,
        InternalOfficeId: '1203',
        Name: 'Amsterdamseweg',
        FullName: 'Amstelveen ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Amsterdamseweg 460',
        VisitingZipcode: '1181 BW',
        VisitingCity: 'Amstelveen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 645 91 66',
        FaxNumber: '',
        Email: 'amstelveen1203@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.317175',
        GeoLocationLongitude: '4.857395',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3728/pandfoto-de-hypotheker-amstelveen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/amstelveen/amsterdamseweg/',
    },
    {
        OfficeId: 2964,
        InternalOfficeId: '1353',
        Name: 'Bijlmerdreef',
        FullName: 'Amsterdam Zuidoost',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Bijlmerdreef 120a-120c',
        VisitingZipcode: '1102 AB',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 416 15 20',
        FaxNumber: '',
        Email: 'amsterdam1353@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.316138',
        GeoLocationLongitude: '4.953482',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3736/pandfoto-de-hypotheker-amsterdam-zuidoost-2021-kopie.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/bijlmerdreef/',
    },
    {
        OfficeId: 2965,
        InternalOfficeId: '1349',
        Name: 'Bos en Lommerplein',
        FullName: 'Amsterdam Bos en Lommerplein',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Bos en Lommerplein 305-307',
        VisitingZipcode: '1-55 RW ',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 581 19 99',
        FaxNumber: '',
        Email: 'amsterdam1349@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.377636',
        GeoLocationLongitude: '4.844295',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3729/pandfoto-de-hypotheker-amsterdam-bos-en-lommer-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/bos-en-lommerplein/',
    },
    {
        OfficeId: 2966,
        InternalOfficeId: '1345',
        Name: 'Buikslotermeerplein',
        FullName: 'Amsterdam Noord',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Buikslotermeerplein 432',
        VisitingZipcode: '1025 WP',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 636 91 22',
        FaxNumber: '',
        Email: 'amsterdam1345@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover de BCC',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.397569',
        GeoLocationLongitude: '4.941202',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3731/pandfoto-de-hypotheker-amsterdam-noord-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/buikslotermeerplein/',
    },
    {
        OfficeId: 2967,
        InternalOfficeId: '1204',
        Name: 'Herengracht',
        FullName: 'Amsterdam Herengracht',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Herengracht 213',
        VisitingZipcode: '1016 BG',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 622 88 51',
        FaxNumber: '',
        Email: 'amsterdam1204@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.373189',
        GeoLocationLongitude: '4.887557',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3730/pandfoto-de-hypotheker-amsterdam-herengracht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/herengracht/',
    },
    {
        OfficeId: 2968,
        InternalOfficeId: '1428',
        Name: 'Middenweg',
        FullName: 'Amsterdam Oost',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Middenweg 241',
        VisitingZipcode: '1098 AP',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 462 40 30',
        FaxNumber: '',
        Email: 'amsterdam1428@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.349335',
        GeoLocationLongitude: '4.938173',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3398/pandfoto-de-hypotheker-amsterdam-oost-2021.jpg?center=0.5625,0.47333333333333333&mode=crop&width=275&height=300&rnd=132712645150000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/middenweg/',
    },
    {
        OfficeId: 2969,
        InternalOfficeId: '1454',
        Name: 'Osdorpplein',
        FullName: 'Amsterdam Osdorp',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Osdorpplein 141',
        VisitingZipcode: '1068 SR',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 707 21 11',
        FaxNumber: '',
        Email: 'amsterdam1454@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Tegenover de Sloterplas, waar de tram de hoek om gaat. 1.5 uur gratis parkeren in de Q-park parkeergarage',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.359748',
        GeoLocationLongitude: '4.806657',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3733/pandfoto-de-hypotheker-amsterdam-osdorp-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/osdorpplein/',
    },
    {
        OfficeId: 2970,
        InternalOfficeId: '1135',
        Name: 'Strawinskylaan',
        FullName: 'Amsterdam ZuidAs WTC',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Strawinskylaan 1427 / WTC',
        VisitingZipcode: '1077 XX',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 662 14 11',
        FaxNumber: '',
        Email: 'amsterdam1135@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Uitstekend bereikbaar per OV. Parkeergelegenheid in het WTC-gebouw',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.340311',
        GeoLocationLongitude: '4.875449',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3735/pandfoto-de-hypotheker-amsterdam-zuidas-wtc-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/strawinskylaan/',
    },
    {
        OfficeId: 2971,
        InternalOfficeId: '1139',
        Name: 'Van Baerlestraat',
        FullName: 'Amsterdam Van Baerlestraat',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Van Baerlestraat 1',
        VisitingZipcode: '1071 AL',
        VisitingCity: 'Amsterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(020) 662 28 61',
        FaxNumber: '',
        Email: 'amsterdam1139@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.360079',
        GeoLocationLongitude: '4.877429',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3734/pandfoto-de-hypotheker-amsterdam-van-baerlestraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-amsterdam/van-baerlestraat/',
    },
    {
        OfficeId: 2972,
        InternalOfficeId: '1127',
        Name: 'Vondellaan',
        FullName: 'Beverwijk ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Vondellaan 2',
        VisitingZipcode: '1942 LJ',
        VisitingCity: 'Beverwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0251) 211 179',
        FaxNumber: '',
        Email: 'beverwijk1127@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover het Rode Kruis Ziekenhuis (kruising Vondellaan/ Velserweg)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.478306',
        GeoLocationLongitude: '4.651267',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '08:30', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3914/pandfoto-de-hypotheker-beverwijk-2021.jpg?center=0.5025,0.42333333333333334&mode=crop&width=275&height=300&rnd=132725420330000000',
        OfficeUrl: '/vestigingen/noord-holland/beverwijk/vondellaan/',
    },
    {
        OfficeId: 2973,
        InternalOfficeId: '1030',
        Name: 'Huizerweg',
        FullName: 'Bussum ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Huizerweg 32',
        VisitingZipcode: '1402 AC',
        VisitingCity: 'Bussum',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(035) 693 74 80',
        FaxNumber: '',
        Email: 'bussum1030@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Betaald parkeren voor de deur en gratis verderop in de woonwijk',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.274019',
        GeoLocationLongitude: '5.169433',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3755/pandfoto-de-hypotheker-bussum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/noord-holland/bussum/huizerweg/',
    },
    {
        OfficeId: 2974,
        InternalOfficeId: '1109',
        Name: 'Julianaplein',
        FullName: 'Den Helder ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Julianaplein 34c',
        VisitingZipcode: '1781 HC',
        VisitingCity: 'Den Helder',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0223) 617 400',
        FaxNumber: '',
        Email: 'denhelder1109@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover NS station Den Helder Centraal',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.957818',
        GeoLocationLongitude: '4.759671',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00 - 17:30', CloseTime: '19:00 - 21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00 - 17:30', CloseTime: '19:00 - 21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3628/pandfoto-de-hypotheker-den-helder-2021.jpg?center=0.4125,0.22666666666666666&mode=crop&width=275&height=300&rnd=132712659690000000',
        OfficeUrl: '/vestigingen/noord-holland/den-helder/julianaplein/',
    },
    {
        OfficeId: 2975,
        InternalOfficeId: '1209',
        Name: 'Floresstraat',
        FullName: 'Haarlem Floresstraat',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Floresstraat 1',
        VisitingZipcode: '2022 BB',
        VisitingCity: 'Haarlem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(023) 525 88 84',
        FaxNumber: '',
        Email: 'haarlem1209@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan het Soendaplein',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.399424',
        GeoLocationLongitude: '4.644714',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3942/pandfoto-de-hypotheker-haarlem-floresstraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132744618860000000',
        OfficeUrl: '/vestigingen/noord-holland/haarlem-hypotheekadviseur/floresstraat/',
    },
    {
        OfficeId: 2976,
        InternalOfficeId: '1116',
        Name: 'Claus Sluterweg',
        FullName: 'Haarlem Centrum',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Claus Sluterweg 309',
        VisitingZipcode: '2012 WS',
        VisitingCity: 'Haarlem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(023) 531 14 07',
        FaxNumber: '',
        Email: 'haarlem1116@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.362133',
        GeoLocationLongitude: '4.616348',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4007/pandfoto-haarlem-centrum-claus.png?anchor=center&mode=crop&width=275&height=300&rnd=132785849130000000',
        OfficeUrl: '/vestigingen/noord-holland/haarlem-hypotheekadviseur/claus-sluterweg/',
    },
    {
        OfficeId: 2977,
        InternalOfficeId: '1362',
        Name: 'Gerrit van Assendelftstraat',
        FullName: 'Heemskerk ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Gerrit van Assendelftstraat 4a',
        VisitingZipcode: '1961 NK',
        VisitingCity: 'Heemskerk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0251) 207 080',
        FaxNumber: '',
        Email: 'heemskerk1362@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Bij Burgemeester Nielenplein (hoek Maerelaan)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.510273',
        GeoLocationLongitude: '4.672746',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '20:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '08:30', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3788/pandfoto-de-hypotheker-heemskerk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/heemskerk/gerrit-van-assendelftstraat/',
    },
    {
        OfficeId: 2978,
        InternalOfficeId: '1196',
        Name: 'Gildestraat',
        FullName: 'Heerhugowaard ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Gildestraat 1',
        VisitingZipcode: '1704 AG',
        VisitingCity: 'Heerhugowaard',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(072) 571 72 22',
        FaxNumber: '',
        Email: 'heerhugowaard1196@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Bij de spoorwegovergang naast station Heerhugowaard',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.668943',
        GeoLocationLongitude: '4.819372',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3790/pandfoto-de-hypotheker-heerhugowaard-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/heerhugowaard/gildestraat/',
    },
    {
        OfficeId: 2979,
        InternalOfficeId: '1205',
        Name: 'Langestraat',
        FullName: 'Hilversum ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Langestraat 118',
        VisitingZipcode: '1211 HC',
        VisitingCity: 'Hilversum',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(035) 624 43 02',
        FaxNumber: '',
        Email: 'hilversum1205@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.223388',
        GeoLocationLongitude: '5.172851',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3794/pandfoto-de-hypotheker-hilversum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/hypotheekadviseur-hilversum/langestraat/',
    },
    {
        OfficeId: 2980,
        InternalOfficeId: '1011',
        Name: 'Antje Breijerstraat',
        FullName: 'Hoofddorp ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Antje Breijerstraat 75',
        VisitingZipcode: '2132 ZT',
        VisitingCity: 'Hoofddorp',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(023) 562 19 87',
        FaxNumber: '',
        Email: 'hoofddorp1011@hypotheker.nl',
        OpeningHoursInfo:
            'Op doordeweekse avonden en op zaterdag zijn we alleen op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.301045',
        GeoLocationLongitude: '4.692591',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3795/pandfoto-de-hypotheker-hoofddorp-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/hoofddorp-hypotheekadviseur/antje-breijerstraat/',
    },
    {
        OfficeId: 2981,
        InternalOfficeId: '1451',
        Name: 'Aalburgplein',
        FullName: 'Hoofddorp Floriande',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Aalburgplein 7',
        VisitingZipcode: '2134 DM',
        VisitingCity: 'Hoofddorp',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(023) 303 12 22',
        FaxNumber: '',
        Email: 'hoofddorp1451@hypotheker.nl',
        OpeningHoursInfo:
            'Op doordeweekse avonden en op zaterdag zijn we alleen op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.30685',
        GeoLocationLongitude: '4.639835',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3796/pandfoto-de-hypotheker-hoofddorp-floriande-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/hoofddorp-hypotheekadviseur/aalburgplein/',
    },
    {
        OfficeId: 2982,
        InternalOfficeId: '1097',
        Name: 'Dal',
        FullName: 'Hoorn ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Dal 8',
        VisitingZipcode: '1621 HP',
        VisitingCity: 'Hoorn',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0229) 230 001',
        FaxNumber: '',
        Email: 'hoorn1097@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.642961',
        GeoLocationLongitude: '5.056412',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3908/pandfoto-de-hypotheker-hoorn-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725379620000000',
        OfficeUrl: '/vestigingen/noord-holland/hoorn/dal/',
    },
    {
        OfficeId: 2983,
        InternalOfficeId: '1207',
        Name: 'Plein 2000',
        FullName: 'Huizen ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Plein 2000 137a',
        VisitingZipcode: '1271 KP',
        VisitingCity: 'Huizen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(035) 525 95 04',
        FaxNumber: '',
        Email: 'huizen1207@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.299834',
        GeoLocationLongitude: '5.2406',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3800/pandfoto-de-hypotheker-huizen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/huizen/plein-2000/',
    },
    {
        OfficeId: 2984,
        InternalOfficeId: '1369',
        Name: 'Marktplein',
        FullName: 'Ijmuiden ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Marktplein 40a',
        VisitingZipcode: '1972 GC',
        VisitingCity: 'IJmuiden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0255) 52 53 20',
        FaxNumber: '',
        Email: 'ijmuiden1369@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan winkelstraat de Lange Nieuwstraat',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.458286',
        GeoLocationLongitude: '4.615483',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3801/pandfoto-de-hypotheker-ijmuiden-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/ijmuiden/marktplein/',
    },
    {
        OfficeId: 2985,
        InternalOfficeId: '1443',
        Name: 'Venneperhof',
        FullName: 'Nieuw Vennep ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Venneperhof 98',
        VisitingZipcode: '2151 AZ',
        VisitingCity: 'Nieuw Vennep',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0252) 62 91 11',
        FaxNumber: '',
        Email: 'nieuwvennep1443@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Bij winkelcentrum de Symfonie, onder de Dirk van den Broek',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.263835',
        GeoLocationLongitude: '4.632333',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3820/pandfoto-de-hypotheker-nieuw-vennep-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/noord-holland/nieuw-vennep/venneperhof/',
    },
    {
        OfficeId: 2986,
        InternalOfficeId: '1278',
        Name: 'Looiersplein',
        FullName: 'Purmerend ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Looiersplein 4',
        VisitingZipcode: '1441 DG',
        VisitingCity: 'Purmerend',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0299) 714 800',
        FaxNumber: '',
        Email: 'purmerend1278@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.508521',
        GeoLocationLongitude: '4.95145',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3325/pandfoto-de-hypotheker-purmerend.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132170120890000000',
        OfficeUrl: '/vestigingen/noord-holland/purmerend/looiersplein/',
    },
    {
        OfficeId: 2987,
        InternalOfficeId: '1448',
        Name: 'Rensgars',
        FullName: 'Schagen ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Rensgars 18',
        VisitingZipcode: '1741 BR',
        VisitingCity: 'Schagen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0224) 23 92 39',
        FaxNumber: '',
        Email: 'schagen1448@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast de Grote Kerk',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.786389',
        GeoLocationLongitude: '4.795927',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:30 - 17:00', CloseTime: '18:30 - 20:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:30', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3845/pandfoto-de-hypotheker-schagen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/noord-holland/schagen/rensgars/',
    },
    {
        OfficeId: 2988,
        InternalOfficeId: '1447',
        Name: 'Marktplein',
        FullName: 'Uithoorn ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Marktplein 7',
        VisitingZipcode: '1421 AC',
        VisitingCity: 'Uithoorn',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0297) 523 690',
        FaxNumber: '',
        Email: 'uithoorn1447@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de Amstel',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.233069',
        GeoLocationLongitude: '4.832389',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3858/pandfoto-de-hypotheker-uithoorn-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/noord-holland/uithoorn/marktplein/',
    },
    {
        OfficeId: 2990,
        InternalOfficeId: '1134',
        Name: 'Prins Bernhardplein',
        FullName: 'Zaandam ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Prins Bernhardplein 1',
        VisitingZipcode: '1508 XA',
        VisitingCity: 'Zaandam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(075) 655 57 77',
        FaxNumber: '',
        Email: 'zaandam1134@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover de McDonalds aan de rotonde',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.453894',
        GeoLocationLongitude: '4.821333',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '21:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3926/pandfoto-de-hypotheker-zaandam-2021.jpg?center=0.4975,0.64833333333333332&mode=crop&width=275&height=300&rnd=132725455730000000',
        OfficeUrl: '/vestigingen/noord-holland/zaandam/prins-bernhardplein/',
    },
    {
        OfficeId: 2991,
        InternalOfficeId: '1456',
        Name: 'Galle Promenade',
        FullName: 'Velserbroek ',
        ProvinceId: '2230',
        ProvinceName: 'Noord-Holland',
        VisitingStreetName: 'Galle Promenade 40',
        VisitingZipcode: '1991 PR',
        VisitingCity: 'Velserbroek',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(023) 303 59 84',
        FaxNumber: '',
        Email: 'velserbroek1456@hypotheker.nl',
        OpeningHoursInfo:
            'Op overige doordeweekse avonden is een afspraak mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In Winkelcentrum Velserbroek',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.433992',
        GeoLocationLongitude: '4.659826',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3923/pandfoto-de-hypotheker-velserbroek-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725450660000000',
        OfficeUrl: '/vestigingen/noord-holland/velserbroek/galle-promenade/',
    },
    {
        OfficeId: 3069,
        InternalOfficeId: '1092',
        Name: 'Oranjestraat',
        FullName: 'Almelo ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Oranjestraat 29',
        VisitingZipcode: '7607 BH',
        VisitingCity: 'Almelo',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0546) 815 222',
        FaxNumber: '',
        Email: 'almelo1092@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.3596',
        GeoLocationLongitude: '6.666974',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3452/pandfoto-de-hypotheker-almelo-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132717823990000000',
        OfficeUrl: '/vestigingen/overijssel/hypotheekadviseur-almelo/oranjestraat/',
    },
    {
        OfficeId: 3070,
        InternalOfficeId: '1066',
        Name: 'Pikeursbaan',
        FullName: 'Deventer ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Pikeursbaan 1',
        VisitingZipcode: '7411 GT',
        VisitingCity: 'Deventer',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0570) 611 009',
        FaxNumber: '',
        Email: 'deventer1066@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.254663',
        GeoLocationLongitude: '6.161038',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3915/pandfoto-de-hypotheker-deventer-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725423230000000',
        OfficeUrl: '/vestigingen/overijssel/hypotheekadviseur-deventer/pikeursbaan/',
    },
    {
        OfficeId: 3071,
        InternalOfficeId: '1281',
        Name: 'Kuipersdijk',
        FullName: 'Enschede ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Kuipersdijk 18',
        VisitingZipcode: '7512 CH',
        VisitingCity: 'Enschede',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(053) 482 82 82',
        FaxNumber: '',
        Email: 'enschede1281@hypotheker.nl',
        OpeningHoursInfo: 'Op zaterdag zijn wij op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.21551',
        GeoLocationLongitude: '6.89589',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3778/pandfoto-de-hypotheker-enschede-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/overijssel/hypotheekadvies-enschede/kuipersdijk/',
    },
    {
        OfficeId: 3072,
        InternalOfficeId: '1423',
        Name: 'Jhr. von Heijdenstraat',
        FullName: 'Haaksbergen ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Jhr. von Heijdenstraat 1',
        VisitingZipcode: '7481 EC ',
        VisitingCity: 'Haaksbergen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(053) 573 58 55',
        FaxNumber: '',
        Email: 'haaksbergen1423@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.15445',
        GeoLocationLongitude: '6.742878',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3169/pandfoto-de-hypotheker-haaksbergen-2021.jpg?center=0.46,0.43166666666666664&mode=crop&width=275&height=300&rnd=132714097820000000',
        OfficeUrl: '/vestigingen/overijssel/haaksbergen/jhr-von-heijdenstraat/',
    },
    {
        OfficeId: 3073,
        InternalOfficeId: '1103',
        Name: 'Bruchterweg',
        FullName: 'Hardenberg ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Bruchterweg 27',
        VisitingZipcode: '7772 BE',
        VisitingCity: 'Hardenberg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0523) 268 070',
        FaxNumber: '',
        Email: 'hardenberg1103@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover het gemeentehuis',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.573569',
        GeoLocationLongitude: '6.618104',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3786/pandfoto-de-hypotheker-hardenberg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/overijssel/hardenberg/bruchterweg/',
    },
    {
        OfficeId: 3074,
        InternalOfficeId: '1146',
        Name: 'Deldenerstraat',
        FullName: 'Hengelo ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Deldenerstraat 55',
        VisitingZipcode: '7551 AB',
        VisitingCity: 'Hengelo',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(074) 242 32 10',
        FaxNumber: '',
        Email: 'hengelo1146@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Parkeren aan het Mitchamplein of aan de Marskant (beide betaald)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.266488',
        GeoLocationLongitude: '6.788046',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4006/office_1146.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132785286860000000',
        OfficeUrl: '/vestigingen/overijssel/hengelo/deldenerstraat/',
    },
    {
        OfficeId: 3075,
        InternalOfficeId: '1439',
        Name: 'Burgwal',
        FullName: 'Kampen ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Burgwal 89-90',
        VisitingZipcode: '8261 ES',
        VisitingCity: 'Kampen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(038) 376 80 60',
        FaxNumber: '',
        Email: 'kampen1439@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Vlakbij de Albert Heijn',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.55957',
        GeoLocationLongitude: '5.913923',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3804/pandfoto-de-hypotheker-kampen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/overijssel/kampen/burgwal/',
    },
    {
        OfficeId: 3076,
        InternalOfficeId: '1105',
        Name: 'Maximastraat',
        FullName: 'Nijverdal ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Máximastraat 7',
        VisitingZipcode: '7442 NW',
        VisitingCity: 'Nijverdal',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0548) 620 922',
        FaxNumber: '',
        Email: 'nijverdal1105@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Aan de rand van het centrum van Nijverdal, tegenover parkeergarage Henri Dunant',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.364891',
        GeoLocationLongitude: '6.463042',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3635/pandfoto-de-hypotheker-nijverdal-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132714111280000000',
        OfficeUrl: '/vestigingen/overijssel/nijverdal/maximastraat/',
    },
    {
        OfficeId: 3077,
        InternalOfficeId: '1164',
        Name: 'Spoorstraat',
        FullName: 'Oldenzaal ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Spoorstraat 5',
        VisitingZipcode: '7573 AL',
        VisitingCity: 'Oldenzaal',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0541) 53 37 20',
        FaxNumber: '',
        Email: 'oldenzaal1164@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.308371',
        GeoLocationLongitude: '6.927906',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3893/pandfoto-de-hypotheker-oldenzaal-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/overijssel/oldenzaal/spoorstraat/',
    },
    {
        OfficeId: 3078,
        InternalOfficeId: '1410',
        Name: 'Schoolstraat',
        FullName: 'Raalte ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Schoolstraat 16',
        VisitingZipcode: '8102 EM',
        VisitingCity: 'Raalte',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0572) 701 000',
        FaxNumber: '',
        Email: 'deventer1066@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.387277',
        GeoLocationLongitude: '6.278463',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '13:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3314/pandfoto-de-hypotheker-raalte-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132714116540000000',
        OfficeUrl: '/vestigingen/overijssel/raalte/schoolstraat/',
    },
    {
        OfficeId: 3079,
        InternalOfficeId: '1463',
        Name: 'Stationsstraat',
        FullName: 'Steenwijk ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Stationsstraat 17',
        VisitingZipcode: '8331 GJ',
        VisitingCity: 'Steenwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0521) 707 025',
        FaxNumber: '',
        Email: 'steenwijk1463@hypotheker.nl',
        OpeningHoursInfo: 'Let op: bovenstaande openingstijden zijn alleen op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.789274',
        GeoLocationLongitude: '6.12061',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3852/pandfoto-de-hypotheker-steenwijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/overijssel/steenwijk/stationsstraat/',
    },
    {
        OfficeId: 3080,
        InternalOfficeId: '1086',
        Name: 'Melkmarkt',
        FullName: 'Zwolle ',
        ProvinceId: '2418',
        ProvinceName: 'Overijssel',
        VisitingStreetName: 'Melkmarkt 43',
        VisitingZipcode: '8011 MB',
        VisitingCity: 'Zwolle',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(038) 421 57 10',
        FaxNumber: '',
        Email: 'zwolle1086@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Op 100 m afstand van de Mediamarkt, naast La Cubanita',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.513101',
        GeoLocationLongitude: '6.090337',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3927/pandfoto-de-hypotheker-zwolle-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725456590000000',
        OfficeUrl: '/vestigingen/overijssel/hypotheekadviseur-zwolle/melkmarkt/',
    },
    {
        OfficeId: 2992,
        InternalOfficeId: '1436',
        Name: 'Het Masker',
        FullName: 'Amersfoort Noord',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Het Masker 218',
        VisitingZipcode: '3823 GX',
        VisitingCity: 'Amersfoort',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(033) 450 81 00',
        FaxNumber: '',
        Email: 'amersfoort1436@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de rand van winkelcentrum Emiclaer',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.187068',
        GeoLocationLongitude: '5.396137',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3727/pandfoto-de-hypotheker-amersfoort-noord-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-amersfoort/het-masker/',
    },
    {
        OfficeId: 2993,
        InternalOfficeId: '1012',
        Name: 'Snouckaertlaan',
        FullName: 'Amersfoort Centrum',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Snouckaertlaan 2',
        VisitingZipcode: '3811 MB',
        VisitingCity: 'Amersfoort',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(033) 461 34 44',
        FaxNumber: '',
        Email: 'amersfoort1012@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Achter onze vestiging kun je gratis parkeren. Vraag bij de vestiging om de exacte locatie. ',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.153138',
        GeoLocationLongitude: '5.383163',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:00', CloseTime: '20:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3726/pandfoto-de-hypotheker-amersfoort-centrum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-amersfoort/snouckaertlaan/',
    },
    {
        OfficeId: 2994,
        InternalOfficeId: '1113',
        Name: 'De Molen',
        FullName: 'Houten ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'De Molen 6a',
        VisitingZipcode: '3994 DB',
        VisitingCity: 'Houten',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 637 65 45',
        FaxNumber: '',
        Email: 'houten1113@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.027771',
        GeoLocationLongitude: '5.176059',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3799/pandfoto-de-hypotheker-houten-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/utrecht/houten/de-molen/',
    },
    {
        OfficeId: 2995,
        InternalOfficeId: '1129',
        Name: 'Safariweg',
        FullName: 'Maarssen ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Safariweg 3',
        VisitingZipcode: '3605 MA',
        VisitingCity: 'Maarssen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0346) 587 272',
        FaxNumber: '',
        Email: 'maarssen1129@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast het station',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.13558',
        GeoLocationLongitude: '5.032907',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3085/pandfoto-de-hypotheker-maarssen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731070000000',
        OfficeUrl: '/vestigingen/utrecht/maarssen/safariweg/',
    },
    {
        OfficeId: 2996,
        InternalOfficeId: '1213',
        Name: 'Weverstede',
        FullName: 'Nieuwegein ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Weverstede 1',
        VisitingZipcode: '3431 JS',
        VisitingCity: 'Nieuwegein',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 605 37 00',
        FaxNumber: '',
        Email: 'nieuwegein1213@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis parkeren naast de vestiging',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.027692',
        GeoLocationLongitude: '5.080534',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3933/pandfoto-de-hypotheker-nieuwegein-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132729860010000000',
        OfficeUrl: '/vestigingen/utrecht/nieuwegein/weverstede/',
    },
    {
        OfficeId: 2997,
        InternalOfficeId: '1128',
        Name: 'Stadhouderslaan',
        FullName: 'Soest ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Stadhouderslaan 1a',
        VisitingZipcode: '3761 EJ',
        VisitingCity: 'Soest',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(035) 603 60 00',
        FaxNumber: '',
        Email: 'soest1128@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden en op zaterdag zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.186284',
        GeoLocationLongitude: '5.296403',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '08:30', CloseTime: '12:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3912/pandfoto-de-hypotheker-soest-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725409310000000',
        OfficeUrl: '/vestigingen/utrecht/soest/stadhouderslaan/',
    },
    {
        OfficeId: 2999,
        InternalOfficeId: '1313',
        Name: 'Pablo Picassostraat',
        FullName: 'Utrecht Leidsche Rijn',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Pablo Picassostraat 101',
        VisitingZipcode: '3544 NX',
        VisitingCity: 'Utrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 711 14 00',
        FaxNumber: '',
        Email: 'utrecht1313@hypotheker.nl',
        OpeningHoursInfo:
            'Wij zijn maandag t/m donderdag telefonisch bereikbaar van 09:30 tot 21:00 uur en vrijdag van 08:30 tot 17:30 uur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Onderin een appartementencomplex, vlak naast/ in de buurt van de Intratuin',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.100353',
        GeoLocationLongitude: '5.031578',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3859/pandfoto-de-hypotheker-utrecht-leidsche-rijn-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-utrecht/pablo-picassostraat/',
    },
    {
        OfficeId: 3000,
        InternalOfficeId: '1435',
        Name: 'Pretoriadreef',
        FullName: 'Utrecht Overvecht',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Pretoriadreef 1-2',
        VisitingZipcode: '3564 BX',
        VisitingCity: 'Utrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 262 73 00',
        FaxNumber: '',
        Email: 'utrecht1435@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.120473',
        GeoLocationLongitude: '5.113495',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3860/pandfoto-de-hypotheker-utrecht-overvecht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-utrecht/pretoriadreef/',
    },
    {
        OfficeId: 3001,
        InternalOfficeId: '1013',
        Name: 'St. Jacobsstraat',
        FullName: 'Utrecht St. Jacobsstraat',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'St. Jacobsstraat 325',
        VisitingZipcode: '3511 BP',
        VisitingCity: 'Utrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 234 34 00',
        FaxNumber: '',
        Email: 'utrecht1013@hypotheker.nl',
        OpeningHoursInfo:
            'Wij zijn maandag t/m donderdag telefonisch bereikbaar van 09:30 tot 21:00 uur en vrijdag van 08:30 tot 17:30 uur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover “Het bronzen Paard” en naast de brug naar Oudenoord',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.096279',
        GeoLocationLongitude: '5.113797',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3861/pandfoto-de-hypotheker-utrecht-st-jacobusstraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-utrecht/st-jacobsstraat/',
    },
    {
        OfficeId: 3002,
        InternalOfficeId: '1412',
        Name: 'Westerkade',
        FullName: 'Utrecht Westerkade',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Westerkade 1',
        VisitingZipcode: '3511 HA',
        VisitingCity: 'Utrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 234 34 00',
        FaxNumber: '',
        Email: 'utrecht1013@hypotheker.nl',
        OpeningHoursInfo:
            'Wij zijn maandag t/m donderdag telefonisch bereikbaar van 09:30 tot 21:00 uur en vrijdag van 08:30 tot 17:30 uur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tussen Ledig Erf en station Vaartsche Rijn',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.080881',
        GeoLocationLongitude: '5.123416',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1095/office_1412-1.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731060000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-utrecht/westerkade/',
    },
    {
        OfficeId: 3003,
        InternalOfficeId: '1130',
        Name: 'Weverij',
        FullName: 'Veenendaal ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Weverij 3b',
        VisitingZipcode: '3905 EV',
        VisitingCity: 'Veenendaal',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0318) 540 210',
        FaxNumber: '',
        Email: 'veenendaal1130@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.02975',
        GeoLocationLongitude: '5.552759',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3864/pandfoto-de-hypotheker-veenendaal-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/hypotheekadviseur-veenendaal/weverij/',
    },
    {
        OfficeId: 3004,
        InternalOfficeId: '1114',
        Name: 'Meulmansweg',
        FullName: 'Woerden ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Meulmansweg 47',
        VisitingZipcode: '3441 AT',
        VisitingCity: 'Woerden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0348) 433 266',
        FaxNumber: '',
        Email: 'woerden1114@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover parkeergarage Castellum',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.085845',
        GeoLocationLongitude: '4.882117',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3879/pandfoto-de-hypotheker-woerden-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/woerden/meulmansweg/',
    },
    {
        OfficeId: 3005,
        InternalOfficeId: '1082',
        Name: 'Antonlaan',
        FullName: 'Zeist ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Antonlaan 187-1',
        VisitingZipcode: '3707 KA',
        VisitingCity: 'Zeist',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 760 76 50',
        FaxNumber: '',
        Email: 'zeist1082@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tussen de Hoogvliet en Stan en Co. 4 uur gratis parkeren',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.089546',
        GeoLocationLongitude: '5.247516',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3882/pandfoto-de-hypotheker-zeist-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/utrecht/zeist/antonlaan/',
    },
    {
        OfficeId: 7304,
        InternalOfficeId: '1469',
        Name: 'Schuttersgracht',
        FullName: 'Ijsselstein ',
        ProvinceId: '2231',
        ProvinceName: 'Utrecht',
        VisitingStreetName: 'Schuttersgracht 12a',
        VisitingZipcode: '3401 DD',
        VisitingCity: 'IJsselstein',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(030) 765 16 00',
        FaxNumber: '',
        Email: 'ijsselstein1469@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast de Action',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.018612',
        GeoLocationLongitude: '5.043501',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3907/pandfoto-de-hypotheker-ijsselstein-2021.jpg?center=0.52,0.45333333333333331&mode=crop&width=275&height=300&rnd=132725377190000000',
        OfficeUrl: '/vestigingen/utrecht/ijsselstein/schuttersgracht/',
    },
    {
        OfficeId: 3065,
        InternalOfficeId: '1141',
        Name: 'Wulfaertstraat',
        FullName: 'Goes ',
        ProvinceId: '2417',
        ProvinceName: 'Zeeland',
        VisitingStreetName: 'Wulffaertstraat 7',
        VisitingZipcode: '4461 HS',
        VisitingCity: 'Goes',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0113) 271 880',
        FaxNumber: '',
        Email: 'goes1141@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Gratis parkeren aan de achterkant van de vestiging. Bereikbaar via de inrit bij naar het CZ gebouw',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.498932',
        GeoLocationLongitude: '3.893204',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3780/pandfoto-de-hypotheker-goes-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zeeland/goes/wulfaertstraat/',
    },
    {
        OfficeId: 3066,
        InternalOfficeId: '1089',
        Name: 'Segeersstraat',
        FullName: 'Middelburg ',
        ProvinceId: '2417',
        ProvinceName: 'Zeeland',
        VisitingStreetName: 'Segeerstraat 9',
        VisitingZipcode: '4331 JM',
        VisitingCity: 'Middelburg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0118) 640 200',
        FaxNumber: '',
        Email: 'middelburg1089@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.498335',
        GeoLocationLongitude: '3.615346',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3818/pandfoto-de-hypotheker-middelburg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zeeland/middelburg/segeersstraat/',
    },
    {
        OfficeId: 3067,
        InternalOfficeId: '1212',
        Name: 'Herengracht',
        FullName: 'Terneuzen ',
        ProvinceId: '2417',
        ProvinceName: 'Zeeland',
        VisitingStreetName: 'Herengracht 4-5',
        VisitingZipcode: '4531 GM',
        VisitingCity: 'Terneuzen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0115) 697 424',
        FaxNumber: '',
        Email: 'terneuzen1212@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken op doordeweekse avonden zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.3355',
        GeoLocationLongitude: '3.828259',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/4014/12.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132790190720000000',
        OfficeUrl: '/vestigingen/zeeland/terneuzen/herengracht/',
    },
    {
        OfficeId: 3068,
        InternalOfficeId: '1159',
        Name: 'Badhuisstraat',
        FullName: 'Vlissingen ',
        ProvinceId: '2417',
        ProvinceName: 'Zeeland',
        VisitingStreetName: 'Badhuisstraat 4',
        VisitingZipcode: '4381 LS',
        VisitingCity: 'Vlissingen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0118) 430 004',
        FaxNumber: '',
        Email: 'vlissingen1159@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In het centrum van Vlissingen, vlakbij de Albert Heijn',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.445642',
        GeoLocationLongitude: '3.571915',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3871/pandfoto-de-hypotheker-vlissingen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zeeland/vlissingen/badhuisstraat/',
    },
    {
        OfficeId: 2913,
        InternalOfficeId: '1091',
        Name: 'Thorbeckestraat',
        FullName: 'Alphen Aan Den Rijn ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Thorbeckstraat 1E',
        VisitingZipcode: '2406 CM',
        VisitingCity: 'Alphen aan den Rijn',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0172) 425 194',
        FaxNumber: '',
        Email: 'alphen1091@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Onder onze vestiging kun je gratis parkeren. Ga direct voor ons pand rechts; na 10 meter vind je links de ingang aan de Ortolaanstraat.',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.131453',
        GeoLocationLongitude: '4.665579',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3725/pandfoto-de-hypotheker-alphen-aan-den-rijn-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/alphen-aan-den-rijn/thorbeckestraat/',
    },
    {
        OfficeId: 2914,
        InternalOfficeId: '1119',
        Name: 'Achterom',
        FullName: 'Barendrecht ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Achterom 1',
        VisitingZipcode: '2991 CP',
        VisitingCity: 'Barendrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0180) 613 599',
        FaxNumber: '',
        Email: 'barendrecht1119@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken op doordeweekse avonden en op zaterdag zijn mogelijk in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.853299',
        GeoLocationLongitude: '4.540282',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:30', CloseTime: '15:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3902/pandfoto-de-hypotheker-barendrecht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719130000000',
        OfficeUrl: '/vestigingen/zuid-holland/barendrecht/achterom/',
    },
    {
        OfficeId: 2915,
        InternalOfficeId: '1406',
        Name: 'Kerkstraat',
        FullName: 'Berkel En Rodenrijs ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Kerkstraat 26',
        VisitingZipcode: '2651 CE',
        VisitingCity: 'Berkel en Rodenrijs',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 313 35 35',
        FaxNumber: '',
        Email: 'berkelenrodenrijs1406@hypotheker.nl',
        OpeningHoursInfo: 'Op zaterdag zijn wij alleen op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.993308',
        GeoLocationLongitude: '4.47781',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3747/pandfoto-de-hypotheker-berkel-en-rodenrijs-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/berkel-en-rodenrijs/kerkstraat/',
    },
    {
        OfficeId: 2916,
        InternalOfficeId: '1426',
        Name: 'Marktstraat',
        FullName: 'Bodegraven ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Marktstraat 6',
        VisitingZipcode: '2411 BE',
        VisitingCity: 'Bodegraven',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0172) 251 040',
        FaxNumber: '',
        Email: 'bodegraven1426@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.085559',
        GeoLocationLongitude: '4.747436',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3750/pandfoto-de-hypotheker-bodegraven-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/bodegraven/marktstraat/',
    },
    {
        OfficeId: 2917,
        InternalOfficeId: '1433',
        Name: 'Turfkade',
        FullName: 'Brielle ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Turfkade 17',
        VisitingZipcode: '3231 AR',
        VisitingCity: 'Brielle',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0181) 391 298',
        FaxNumber: '',
        Email: 'brielle1433@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.901214',
        GeoLocationLongitude: '4.165163',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3754/pandfoto-de-hypotheker-brielle-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/brielle/turfkade/',
    },
    {
        OfficeId: 2918,
        InternalOfficeId: '1111',
        Name: 'Fluiterlaan',
        FullName: 'Capelle Aan Den Ijssel ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Fluiterlaan 425',
        VisitingZipcode: '2903 HN',
        VisitingCity: 'Capelle aan den IJssel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 458 26 89',
        FaxNumber: '',
        Email: 'capelle1111@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: "Naast winkelcentrum 'De Koperwiek'",
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.932243',
        GeoLocationLongitude: '4.5873',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3756/pandfoto-de-hypotheker-capelle-aan-den-ijssel-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/capelle-aan-den-ijssel/fluiterlaan/',
    },
    {
        OfficeId: 2919,
        InternalOfficeId: '1200',
        Name: 'Westlandseweg',
        FullName: 'Delft ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Westlandseweg 13',
        VisitingZipcode: '2624 AA',
        VisitingCity: 'Delft',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(015) 214 29 72',
        FaxNumber: '',
        Email: 'delft1200@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast fietsenzaak Wijtmans en tegenover de brandweer',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.002488',
        GeoLocationLongitude: '4.355292',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: true,
        ImageUrl:
            'https://www.hypotheker.nl/media/3759/pandfoto-de-hypotheker-delft-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/delft/westlandseweg/',
    },
    {
        OfficeId: 2920,
        InternalOfficeId: '1004',
        Name: 'Koninginnegracht',
        FullName: 'Den Haag Koninginnegracht',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Koninginnegracht 36G',
        VisitingZipcode: '2514 AC',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 362 11 88',
        FaxNumber: '',
        Email: 'denhaag1004@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Nabij het Malieveld',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.089609',
        GeoLocationLongitude: '4.311898',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00 - 17:30', CloseTime: '18:00 - 20:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00 - 17:30', CloseTime: '18:00 - 20:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00 - 17:30', CloseTime: '18:00 - 20:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00 - 17:30', CloseTime: '18:00 - 20:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00 - 17:30', CloseTime: '00:00 - 00:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:15 - 13:30', CloseTime: '00:00 - 00:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3761/pandfoto-de-hypotheker-den-haag-koninginnegracht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/koninginnegracht/',
    },
    {
        OfficeId: 2921,
        InternalOfficeId: '1183',
        Name: 'Leyweg',
        FullName: 'Den Haag Leyweg',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Hengelolaan 175D',
        VisitingZipcode: '2545 JE',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 308 24 90',
        FaxNumber: '',
        Email: 'denhaag1183@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Tegenover winkelcentrum en bushalte Leyweg. Gratis parkeren aan de rechterkant van de vestiging',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.050022',
        GeoLocationLongitude: '4.273452',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3762/pandfoto-de-hypotheker-den-haag-leyweg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/leyweg/',
    },
    {
        OfficeId: 2922,
        InternalOfficeId: '1336',
        Name: 'Lorentzplein',
        FullName: 'Den Haag Lorentzplein',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Lorentzplein 25',
        VisitingZipcode: '2522 EC',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 415 49 40',
        FaxNumber: '',
        Email: 'denhaag1336@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis parkeren tot 18:00 uur rondom de vestiging',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.060809',
        GeoLocationLongitude: '4.32685',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '16:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3763/pandfoto-de-hypotheker-den-haag-lorentzplein-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/lorentzplein/',
    },
    {
        OfficeId: 2923,
        InternalOfficeId: '1124',
        Name: 'Theresiastraat',
        FullName: 'Den Haag Theresiastraat',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Theresiastraat 13',
        VisitingZipcode: '2593 AA',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 315 40 15',
        FaxNumber: '',
        Email: 'denhaag1124@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.082788',
        GeoLocationLongitude: '4.329979',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3765/pandfoto-de-hypotheker-den-haag-theresiastraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/theresiastraat/',
    },
    {
        OfficeId: 2924,
        InternalOfficeId: '1440',
        Name: 'Turfmarkt',
        FullName: 'Den Haag Stadhuis',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Turfmarkt 16',
        VisitingZipcode: '2511 CA',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 205 02 56',
        FaxNumber: '',
        Email: 'denhaag1440@hypotheker.nl',
        OpeningHoursInfo: 'Op zaterdag zijn wij op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de zijkant van het Stadhuis, grenzend aan het Spui',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.078178',
        GeoLocationLongitude: '4.318161',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:30', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:30', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3764/pandfoto-de-hypotheker-den-haag-stadhuis-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/turfmarkt/',
    },
    {
        OfficeId: 2925,
        InternalOfficeId: '1078',
        Name: 'Valeriusstraat',
        FullName: 'Den Haag Valeriusstraat',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Valeriusstraat 91',
        VisitingZipcode: '2517 HP',
        VisitingCity: 'Den Haag',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 361 40 52',
        FaxNumber: '',
        Email: 'denhaag1078@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.086482',
        GeoLocationLongitude: '4.279134',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3766/pandfoto-de-hypotheker-den-haag-valeriusstraat-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719100000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-den-haag/valeriusstraat/',
    },
    {
        OfficeId: 2926,
        InternalOfficeId: '1154',
        Name: 'Johan de Wittstraat',
        FullName: 'Dordrecht Centrum',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Johan de Wittstraat 160',
        VisitingZipcode: '3311 KJ',
        VisitingCity: 'Dordrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(078) 631 01 99',
        FaxNumber: '',
        Email: 'dordrecht1154@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Aan de doorgaande weg naar het treinstation',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.810051',
        GeoLocationLongitude: '4.668354',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3771/pandfoto-de-hypotheker-dordrecht-centrum-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-dordrecht/johan-de-wittstraat/',
    },
    {
        OfficeId: 2927,
        InternalOfficeId: '1422',
        Name: 'Van Eesterenplein',
        FullName: 'Dordrecht Stadspolders',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Van Eesterenplein 254',
        VisitingZipcode: '3315 KW',
        VisitingCity: 'Dordrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(078) 630 97 25',
        FaxNumber: '',
        Email: 'dordrecht1422@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Om de hoek bij de HEMA. Gratis parkeren voor de deur',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.803029',
        GeoLocationLongitude: '4.715271',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '19:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3916/pandfoto-de-hypotheker-dordrecht-stadspolders-2021.jpg?center=0.505,0.37666666666666665&mode=crop&width=275&height=300&rnd=132725426260000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-dordrecht/van-eesterenplein/',
    },
    {
        OfficeId: 2928,
        InternalOfficeId: '1059',
        Name: 'Banneweg',
        FullName: 'Gorinchem ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Banneweg 8',
        VisitingZipcode: '4205 KX',
        VisitingCity: 'Gorinchem',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0183) 610 310',
        FaxNumber: '',
        Email: 'gorinchem1059@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover het Piazza Center, gratis parkeren',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.838132',
        GeoLocationLongitude: '4.962736',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3588/pandfoto-de-hypotheker-gorinchem-2021.jpg?center=0.5175,0.51666666666666672&mode=crop&width=275&height=300&rnd=132714189830000000',
        OfficeUrl: '/vestigingen/zuid-holland/gorinchem/banneweg/',
    },
    {
        OfficeId: 2929,
        InternalOfficeId: '1279',
        Name: 'Agnietenstraat',
        FullName: 'Gouda ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Agnietenstraat 46',
        VisitingZipcode: '2801 HX',
        VisitingCity: 'Gouda',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0182) 547 400',
        FaxNumber: '',
        Email: 'gouda1279@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast de Nieuwe Markt Passage. Parkeermogelijkheid bij Q-park Nieuwe Markt',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.014402',
        GeoLocationLongitude: '4.710968',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3782/pandfoto-de-hypotheker-gouda-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-gouda/agnietenstraat/',
    },
    {
        OfficeId: 2930,
        InternalOfficeId: '1405',
        Name: 'Bruggehoofd',
        FullName: 'Hellevoetsluis ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Bruggehoofd 1A',
        VisitingZipcode: '3233 DB',
        VisitingCity: 'Hellevoetsluis',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0181) 39 12 91',
        FaxNumber: '',
        Email: 'hellevoetsluis1405@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Aan de rand van de Struytse Hoek, naast Domino’s en tegenover de brandweerkazerne',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.83435',
        GeoLocationLongitude: '4.144113',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3549/pandfoto-de-hypotheker-hellevoetsluis-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723724410000000',
        OfficeUrl: '/vestigingen/zuid-holland/hellevoetsluis/bruggehoofd/',
    },
    {
        OfficeId: 2933,
        InternalOfficeId: '1465',
        Name: 'Nieuwe Tiendweg',
        FullName: 'Krimpen Aan Den Ijssel ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Nieuwe Tiendweg 11a',
        VisitingZipcode: '2922 EN',
        VisitingCity: 'Krimpen aan den IJssel',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0180) 22 22 67',
        FaxNumber: '',
        Email: 'krimpenaandenijssel1465@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.914777',
        GeoLocationLongitude: '4.595958',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3625/pandfoto-de-hypotheker-krimpen-aan-den-ijssel-2021.jpg?center=0.7275,0.50666666666666671&mode=crop&width=275&height=300&rnd=132714193750000000',
        OfficeUrl: '/vestigingen/zuid-holland/krimpen-aan-den-ijssel/nieuwe-tiendweg/',
    },
    {
        OfficeId: 2224,
        InternalOfficeId: '1115',
        Name: 'Lammenschansplein',
        FullName: 'Leiden Lammenschansplein',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Lammenschansplein 6',
        VisitingZipcode: '2321 JB',
        VisitingCity: 'Leiden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(071) 532 01 22',
        FaxNumber: '',
        Email: 'leiden1115@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Direct aan de N206, op de grens tussen Leiden, Voorschoten en Zoeterwoude. Naast de kringloopwinkel',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.142253',
        GeoLocationLongitude: '4.485826',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3808/pandfoto-de-hypotheker-leiden-lammenschansplein-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-leiden/lammenschansplein/',
    },
    {
        OfficeId: 2934,
        InternalOfficeId: '1039',
        Name: 'Schuttersveld',
        FullName: 'Leiden Schuttersveld',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Schuttersveld 4',
        VisitingZipcode: '2316 ZA',
        VisitingCity: 'Leiden',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(071) 521 08 08',
        FaxNumber: '',
        Email: 'leiden1039@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.166691',
        GeoLocationLongitude: '4.485227',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3917/pandfoto-de-hypotheker-leiden-schuttersveld-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725429150000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-leiden/schuttersveld/',
    },
    {
        OfficeId: 2935,
        InternalOfficeId: '1282',
        Name: 'Leidsekade',
        FullName: 'Leidschendam ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Leidsekade 1a',
        VisitingZipcode: '2266 BG',
        VisitingCity: 'Leidschendam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 317 72 75',
        FaxNumber: '',
        Email: 'leidschendam1282@hypotheker.nl',
        OpeningHoursInfo:
            'Op zaterdag zijn wij alleen geopend op basis van afspraak.\n\nParkeren kan in de parkeergarage aan het Damplein (gratis parkeren met blauwe parkeerschijf, maximaal 2 uur)',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Bij de historische sluisjes. ',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.080132',
        GeoLocationLongitude: '4.398972',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3489/pandfoto-de-hypotheker-leidschendam-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723724410000000',
        OfficeUrl: '/vestigingen/zuid-holland/leidschendam/leidsekade/',
    },
    {
        OfficeId: 2936,
        InternalOfficeId: '1242',
        Name: 'Haven',
        FullName: 'Lisse ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Haven 2',
        VisitingZipcode: '2161 HK',
        VisitingCity: 'Lisse',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0252) 42 87 17',
        FaxNumber: '',
        Email: 'lisse1242@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur. Op zaterdag zijn wij op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.258609',
        GeoLocationLongitude: '4.556439',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3918/pandfoto-de-hypotheker-lisse-2021.jpg?center=0.545,0.44333333333333336&mode=crop&width=275&height=300&rnd=132725433990000000',
        OfficeUrl: '/vestigingen/zuid-holland/lisse/haven/',
    },
    {
        OfficeId: 2937,
        InternalOfficeId: '1145',
        Name: 'Wagenstraat',
        FullName: 'Maassluis ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Wagenstraat 33',
        VisitingZipcode: '3142 CR',
        VisitingCity: 'Maassluis',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 590 00 83',
        FaxNumber: '',
        Email: 'maassluis1145@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Gratis parkeren voor de deur',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.923544',
        GeoLocationLongitude: '4.25165',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3557/pandfoto-de-hypotheker-maassluis-2021.jpg?center=0.5025,0.56&mode=crop&width=275&height=300&rnd=132723724410000000',
        OfficeUrl: '/vestigingen/zuid-holland/maassluis/wagenstraat/',
    },
    {
        OfficeId: 2938,
        InternalOfficeId: '1445',
        Name: 'Molenstraat',
        FullName: 'Naaldwijk ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Molenstraat 37',
        VisitingZipcode: '2671 EW',
        VisitingCity: 'Naaldwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0174) 266 367',
        FaxNumber: '',
        Email: 'naaldwijk1445@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast de Calway. Gratis parkeergelegenheid om de hoek',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.994982',
        GeoLocationLongitude: '4.207393',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3819/pandfoto-de-hypotheker-naaldwijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/naaldwijk/molenstraat/',
    },
    {
        OfficeId: 2939,
        InternalOfficeId: '1339',
        Name: 'Parallel Boulevard',
        FullName: 'Noordwijk ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Parallel Boulevard 214C',
        VisitingZipcode: '2202 HT',
        VisitingCity: 'Noordwijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(071) 362 25 30',
        FaxNumber: '',
        Email: 'noordwijk1339@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo:
            'Gratis parkeren op het parkeerterrein van Hotel van Oranje (uitrijkaart in vestiging te verkrijgen)',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.246493',
        GeoLocationLongitude: '4.433535',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '08:30', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '08:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3824/pandfoto-de-hypotheker-noordwijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/noordwijk/parallel-boulevard/',
    },
    {
        OfficeId: 2940,
        InternalOfficeId: '1450',
        Name: 'Dorpsstraat',
        FullName: 'Nootdorp ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Dorpsstraat 12A',
        VisitingZipcode: '2631 CT',
        VisitingCity: 'Nootdorp',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(015) 310 72 10',
        FaxNumber: '',
        Email: 'nootdorp1450@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur. Op zaterdag zijn wij geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover Grieks restaurant Olympia',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.042409',
        GeoLocationLongitude: '4.393633',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '12:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3615/pandfoto-de-hypotheker-nootdorp-2021.jpg?center=0.51,0.54833333333333334&mode=crop&width=275&height=300&rnd=132714208740000000',
        OfficeUrl: '/vestigingen/zuid-holland/nootdorp/dorpsstraat/',
    },
    {
        OfficeId: 2941,
        InternalOfficeId: '1453',
        Name: 'Julianastraat',
        FullName: 'Oud Beijerland ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Julianastraat 9',
        VisitingZipcode: '3262 SH',
        VisitingCity: 'Oud Beijerland',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0186) 62 93 55',
        FaxNumber: '',
        Email: 'oudbeijerland1453@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.823853',
        GeoLocationLongitude: '4.413163',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:30', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:30', CloseTime: '22:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:30', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:30', CloseTime: '13:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3829/pandfoto-de-hypotheker-oud-beijerland-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/oud-beijerland/julianastraat/',
    },
    {
        OfficeId: 2942,
        InternalOfficeId: '1427',
        Name: 'Weteringsingel',
        FullName: 'Papendrecht ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Weteringsingel 4',
        VisitingZipcode: '3353 GZ',
        VisitingCity: 'Papendrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(078) 642 30 00',
        FaxNumber: '',
        Email: 'papendrecht1427@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In winkelcentrum de Meent',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.826819',
        GeoLocationLongitude: '4.684683',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '08:00', CloseTime: '22:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '22:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3830/pandfoto-de-hypotheker-papendrecht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719110000000',
        OfficeUrl: '/vestigingen/zuid-holland/papendrecht/weteringsingel/',
    },
    {
        OfficeId: 8038,
        InternalOfficeId: '1468',
        Name: 'Westlaan',
        FullName: 'Pijnacker ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Westlaan 28',
        VisitingZipcode: '2641 DM ',
        VisitingCity: 'Pijnacker',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '015-2001097',
        FaxNumber: '',
        Email: 'pijnacker1468@hypotheker.nl',
        OpeningHoursInfo: 'In de avonden en op zaterdag zijn wij geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.018641',
        GeoLocationLongitude: '4.428403',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '10:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3633/pandfoto-de-hypotheker-pijnacker-2021.jpg?center=0.5125,0.425&mode=crop&width=275&height=300&rnd=132714211160000000',
        OfficeUrl: '/vestigingen/zuid-holland/pijnacker/westlaan/',
    },
    {
        OfficeId: 2943,
        InternalOfficeId: '1123',
        Name: 'Ridderstraat',
        FullName: 'Ridderkerk ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Ridderstraat 2a',
        VisitingZipcode: '2981 HA',
        VisitingCity: 'Ridderkerk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0180) 423 599',
        FaxNumber: '',
        Email: 'ridderkerk1123@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.868453',
        GeoLocationLongitude: '4.600151',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3833/pandfoto-de-hypotheker-ridderkerk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/ridderkerk/ridderstraat/',
    },
    {
        OfficeId: 2944,
        InternalOfficeId: '1087',
        Name: 'Prinses Beatrixlaan',
        FullName: 'Rijswijk ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Prinses Beatrixlaan 943',
        VisitingZipcode: '2284 BK',
        VisitingCity: 'Rijswijk',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 390 92 50',
        FaxNumber: '',
        Email: 'rijswijk1087@hypotheker.nl',
        OpeningHoursInfo:
            'Afspraken buiten kantoortijden op doordeweekse avonden zijn mogelijk in overleg met de adviseur. Op zaterdag zijn wij geopend op afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'In winkelcentrum de Boogaard',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.0368',
        GeoLocationLongitude: '4.314154',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3834/pandfoto-de-hypotheker-rijswijk-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/rijswijk/prinses-beatrixlaan/',
    },
    {
        OfficeId: 2946,
        InternalOfficeId: '1187',
        Name: 'Adriaen van der Doeslaan',
        FullName: 'Rotterdam Hillegersberg',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Adriaen van der Doeslaan 315',
        VisitingZipcode: '3054 EC',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 418 81 91',
        FaxNumber: '',
        Email: 'rotterdam1187@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Vlakbij de Albert Heijn XL',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.959045',
        GeoLocationLongitude: '4.493202',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3840/pandfoto-de-hypotheker-rotterdam-hillegersberg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl:
            '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/adriaen-van-der-doeslaan/',
    },
    {
        OfficeId: 2947,
        InternalOfficeId: '1206',
        Name: 'Grote Beer',
        FullName: 'Rotterdam Alexandrium',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Grote Beer 19a',
        VisitingZipcode: '3067 TR',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 455 87 77',
        FaxNumber: '',
        Email: 'rotterdam1206@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.948598',
        GeoLocationLongitude: '4.555832',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3838/pandfoto-de-hypotheker-rotterdam-alexandrium-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/grote-beer/',
    },
    {
        OfficeId: 2948,
        InternalOfficeId: '1348',
        Name: 'Oudedijk',
        FullName: 'Rotterdam Kralingen',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Oudedijk 3b',
        VisitingZipcode: '3062 AA',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 253 20 90',
        FaxNumber: '',
        Email: 'rotterdam1348@hypotheker.nl',
        OpeningHoursInfo:
            'De afspraken buiten kantoortijden (maandag t/m vrijdag na 17:30 en op zaterdag) kunnen worden gepland in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Kralingen',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.924512',
        GeoLocationLongitude: '4.516454',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3841/pandfoto-de-hypotheker-rotterdam-kralingen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/oudedijk/',
    },
    {
        OfficeId: 2949,
        InternalOfficeId: '1318',
        Name: 'Stadhoudersweg',
        FullName: 'Rotterdam Blijdorp',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Stadhoudersweg 69-71',
        VisitingZipcode: '3039 EA',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 714 32 10',
        FaxNumber: '',
        Email: 'rotterdam1318@hypotheker.nl',
        OpeningHoursInfo:
            'De afspraken buiten kantoortijden (maandag t/m vrijdag na 17:30 en op zaterdag) kunnen worden gepland in overleg met de adviseur.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.931543',
        GeoLocationLongitude: '4.461435',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3962/pandfoto-de-hypotheker-rotterdam-blijdorp.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132769601130000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/stadhoudersweg/',
    },
    {
        OfficeId: 2950,
        InternalOfficeId: '1036',
        Name: 'Westblaak',
        FullName: 'Rotterdam Westblaak',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Westblaak 232',
        VisitingZipcode: '3012 KP',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 433 21 13',
        FaxNumber: '',
        Email: 'rotterdam1036@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Centrum',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.916186',
        GeoLocationLongitude: '4.474516',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3843/pandfoto-de-hypotheker-rotterdam-westblaak-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/westblaak/',
    },
    {
        OfficeId: 2951,
        InternalOfficeId: '1098',
        Name: 'Zuidplein',
        FullName: 'Rotterdam Zuidplein',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Zuidplein 412-422',
        VisitingZipcode: '3083 CX',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 410 15 99',
        FaxNumber: '',
        Email: 'rotterdam1098@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover politiebureau Zuidplein en het busstation',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.888768',
        GeoLocationLongitude: '4.490143',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '18:00' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '16:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3844/pandfoto-de-hypotheker-rotterdam-zuidplein-2021.jpg?center=0.3925,0.69&mode=crop&width=275&height=300&rnd=132725378100000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/zuidplein/',
    },
    {
        OfficeId: 2952,
        InternalOfficeId: '1441',
        Name: 'Corsicalaan',
        FullName: 'Rotterdam Nesselande',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Corsicalaan 31',
        VisitingZipcode: '3059 XX',
        VisitingCity: 'Rotterdam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 310 62 05',
        FaxNumber: '',
        Email: 'rotterdam1441@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.979907',
        GeoLocationLongitude: '4.582352',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:30', CloseTime: '17:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:30', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3919/pandfoto-de-hypotheker-rotterdam-nesselande-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132725439800000000',
        OfficeUrl: '/vestigingen/zuid-holland/rotterdam-hypotheekadviseur/corsicalaan/',
    },
    {
        OfficeId: 2953,
        InternalOfficeId: '1106',
        Name: 'Broersvest',
        FullName: 'Schiedam ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Broersvest 68C',
        VisitingZipcode: '3112 DG',
        VisitingCity: 'Schiedam',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 473 11 50',
        FaxNumber: '',
        Email: 'schiedam1106@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.916587',
        GeoLocationLongitude: '4.402789',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3328/pandfoto-de-hypotheker-schiedam-2021.jpg?center=0.4925,0.49&mode=crop&width=275&height=300&rnd=132714253270000000',
        OfficeUrl: '/vestigingen/zuid-holland/hypotheekadviseur-schiedam/broersvest/',
    },
    {
        OfficeId: 2954,
        InternalOfficeId: '1104',
        Name: '1e Heulbrugstraat',
        FullName: 'Spijkenisse ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: '1e Heulbrugstraat 1',
        VisitingZipcode: '3201 BE',
        VisitingCity: 'Spijkenisse',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0181) 697 210',
        FaxNumber: '',
        Email: 'spijkenisse1104@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.851544',
        GeoLocationLongitude: '4.326372',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '15:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3850/pandfoto-de-hypotheker-spijkenisse-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/spijkenisse/1e-heulbrugstraat/',
    },
    {
        OfficeId: 2955,
        InternalOfficeId: '1208',
        Name: 'Schiedamseweg',
        FullName: 'Vlaardingen ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Schiedamseweg 10b',
        VisitingZipcode: '3134 BJ',
        VisitingCity: 'Vlaardingen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(010) 471 70 81',
        FaxNumber: '',
        Email: 'vlaardingen1208@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Schuin tegenover de Stadsgehoorzaal Vlaardingen',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.90926',
        GeoLocationLongitude: '4.345826',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '13:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3870/pandfoto-de-hypotheker-vlaardingen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/vlaardingen/schiedamseweg/',
    },
    {
        OfficeId: 2956,
        InternalOfficeId: '1140',
        Name: 'Prins Bernhardlaan',
        FullName: 'Voorburg ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Prins Bernhardlaan 238',
        VisitingZipcode: '2273 BP',
        VisitingCity: 'Voorburg',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(070) 387 78 88',
        FaxNumber: '',
        Email: 'voorburg1140@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Tegenover winkelcentrum De Julianabaan',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.07458',
        GeoLocationLongitude: '4.361422',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3872/pandfoto-de-hypotheker-voorburg-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/voorburg/prins-bernhardlaan/',
    },
    {
        OfficeId: 2957,
        InternalOfficeId: '1429',
        Name: 'Herenstraat',
        FullName: 'Voorhout ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Herenstraat 75',
        VisitingZipcode: '2215 KG',
        VisitingCity: 'Voorhout',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0252) 22 23 42',
        FaxNumber: '',
        Email: 'voorhout1429@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.222514',
        GeoLocationLongitude: '4.484294',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/1080/office_1429.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723731050000000',
        OfficeUrl: '/vestigingen/zuid-holland/voorhout/herenstraat/',
    },
    {
        OfficeId: 2961,
        InternalOfficeId: '1430',
        Name: 'Plein',
        FullName: 'Wateringen ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Plein 2',
        VisitingZipcode: '2291 CC',
        VisitingCity: 'Wateringen',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(0174) 257 030',
        FaxNumber: '',
        Email: 'wateringen1430@hypotheker.nl',
        OpeningHoursInfo: '',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.023671',
        GeoLocationLongitude: '4.274174',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3874/pandfoto-de-hypotheker-wateringen-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/wateringen/plein/',
    },
    {
        OfficeId: 2958,
        InternalOfficeId: '1016',
        Name: 'Zwaardslootseweg',
        FullName: 'Zoetermeer ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Zwaardslootseweg 42',
        VisitingZipcode: '2726 ZZ',
        VisitingCity: 'Zoetermeer',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(079) 342 32 40',
        FaxNumber: '',
        Email: 'zoetermeer1016@hypotheker.nl',
        OpeningHoursInfo:
            'In de avonden en op zaterdagen zijn wij alleen beschikbaar op basis van afspraak.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: 'Naast het woonhart, nabij restaurant de Sniep en het AIVD gebouw',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '52.064263',
        GeoLocationLongitude: '4.49018',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '21:00' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'zaterdag', OpenTime: '09:00', CloseTime: '14:00' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3884/pandfoto-de-hypotheker-zoetermeer-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/zoetermeer/zwaardslootseweg/',
    },
    {
        OfficeId: 2959,
        InternalOfficeId: '1147',
        Name: 'Laan van Walburg',
        FullName: 'Zwijndrecht ',
        ProvinceId: '2222',
        ProvinceName: 'Zuid-Holland',
        VisitingStreetName: 'Laan van Walburg 6',
        VisitingZipcode: '3332 GJ',
        VisitingCity: 'Zwijndrecht',
        MailingStreetName: '',
        MailingHouseNumber: '',
        MailingZipcode: '',
        MailingCity: '',
        TelephoneNumber: '(078) 612 22 22',
        FaxNumber: '',
        Email: 'zwijndrecht1147@hypotheker.nl',
        OpeningHoursInfo:
            'Op maandag- t/m donderdagavond en op zaterdag zijn wij op afspraak geopend.',
        OVInfo: '',
        ParkingInfo: '',
        AddressInfo: '',
        IsActive: true,
        OwnTransportationInfo: '',
        GeoLocationLatitude: '51.821895',
        GeoLocationLongitude: '4.647878',
        OrderedOfficeSchedulingList: [
            { DayOfWeekString: 'maandag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'dinsdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'woensdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'donderdag', OpenTime: '09:00', CloseTime: '17:30' },
            { DayOfWeekString: 'vrijdag', OpenTime: '09:00', CloseTime: '17:30' },
        ],
        CmsImageNodeId: 0,
        PriceZelfzeker: 1495,
        PriceJazeker: 2495,
        PricePluszeker: 3495,
        OnlineTarief: false,
        ImageUrl:
            'https://www.hypotheker.nl/media/3886/pandfoto-de-hypotheker-zwijndrecht-2021.jpg?anchor=center&mode=crop&width=275&height=300&rnd=132723719120000000',
        OfficeUrl: '/vestigingen/zuid-holland/zwijndrecht/laan-van-walburg/',
    },
];
